var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _g, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruckLeftDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 415,
    viewBox: "0 0 421 415",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M107.885 414.842L9.87891 358.782L322.31 180.791L420.317 236.83L107.885 414.842Z",
    fill: "#EFECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M363.367 193.292V197.22L327.152 176.493V172.586L306.439 160.736L303.334 162.711L306.439 178.099L380.997 224.48L384.08 222.505V205.142L363.367 193.292Z",
    fill: "#000F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M360.284 195.288V199.195L324.047 178.468V174.561L303.334 162.711V180.074L380.997 224.479V207.116L360.284 195.288Z",
    fill: "#001E33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M360.422 196.15V199.195V200.057L359.674 199.629L323.437 178.902L323.185 178.758V178.468V174.851L303.472 163.573V179.784L380.113 223.617V207.407L360.422 196.15Z",
    fill: "url(#paint0_linear_3124_5336)",
    stroke: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M227.355 283.774L227.47 283.84H227.49C231.763 286.349 234.398 290.922 234.398 295.863V295.864L234.441 311.591L186.943 338.737L181.262 323.211L181.239 323.148L181.2 323.092L167.366 303.728L214.88 276.645L227.355 283.774Z",
    fill: "#222222",
    stroke: "url(#paint1_linear_3124_5336)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M167.115 327.694V304.429L176.571 309.84L176.572 309.84C182.495 313.223 186.155 319.525 186.155 326.356V338.581L167.115 327.694Z",
    fill: "#222222",
    stroke: "url(#paint2_linear_3124_5336)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M363.341 218.576C363.341 218.576 371.157 221.81 371.461 233.573L366.142 230.773L358.325 224.523L352.789 221.202L350.335 217.968C353.136 213.28 363.341 218.576 363.341 218.576Z",
    fill: "url(#paint3_linear_3124_5336)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M360.545 220.53L346.715 212.543C346.02 212.001 345.26 211.566 344.478 211.241H344.457C341.352 209.96 337.552 210.308 333.449 212.587C322.962 218.425 314.451 234.659 314.451 248.853C314.451 256.905 317.187 262.57 321.464 264.914H321.442L337.77 274.268L337.487 270.817L334.404 263.894C334.404 263.894 334.296 263.785 334.122 263.612C344.326 257.491 352.468 241.626 352.468 227.714C352.468 226.195 352.36 224.741 352.186 223.395H354.444L360.589 220.508L360.545 220.53Z",
    fill: "#000F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M368.904 237.176C368.904 251.37 360.393 267.626 349.906 273.443C339.419 279.281 330.908 272.488 330.908 258.294C330.908 244.1 339.419 227.844 349.906 222.027C360.393 216.189 368.904 222.982 368.904 237.176Z",
    fill: "#222222"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M363.021 240.454C363.021 250.264 357.137 261.485 349.907 265.5C342.655 269.537 336.793 264.849 336.793 255.039C336.793 245.229 342.677 234.008 349.907 229.993C357.159 225.956 363.021 230.644 363.021 240.454Z",
    fill: "url(#paint4_linear_3124_5336)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M360.567 241.822C360.567 249.787 355.79 258.902 349.907 262.18C344.023 265.457 339.246 261.637 339.246 253.672C339.246 245.707 344.023 236.591 349.907 233.314C355.79 230.037 360.567 233.856 360.567 241.822Z",
    fill: "#000F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M359.003 242.689C359.003 249.504 354.922 257.274 349.885 260.073C344.847 262.873 340.766 259.618 340.766 252.803C340.766 245.988 344.847 238.218 349.885 235.418C354.922 232.618 359.003 235.874 359.003 242.689Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M357.896 243.297C357.896 249.265 354.313 256.102 349.906 258.554C345.498 261.007 341.916 258.164 341.916 252.173C341.916 246.183 345.498 239.368 349.906 236.916C354.313 234.463 357.896 237.306 357.896 243.297Z",
    fill: "#222222"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M353.206 245.901C353.206 248.376 351.729 251.197 349.906 252.217C348.082 253.237 346.605 252.043 346.605 249.569C346.605 247.095 348.082 244.274 349.906 243.254C351.729 242.233 353.206 243.427 353.206 245.901Z",
    fill: "#D7F0FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M354.009 246.487C354.009 248.831 352.598 251.522 350.861 252.477C349.124 253.432 347.713 252.325 347.713 249.981C347.713 247.637 349.124 244.946 350.861 243.991C352.598 243.036 354.009 244.143 354.009 246.487Z",
    fill: "url(#paint5_linear_3124_5336)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M356.508 238.496C356.638 238.431 356.747 238.344 356.877 238.236C356.377 237.346 355.726 236.673 354.945 236.261C354.879 236.543 354.836 236.847 354.836 237.129C354.836 238.388 355.596 238.995 356.529 238.474L356.508 238.496Z",
    fill: "url(#paint6_linear_3124_5336)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M355.879 250.129C354.945 250.65 354.186 252.104 354.186 253.363C354.186 253.645 354.229 253.905 354.294 254.101C355.163 252.842 355.922 251.431 356.509 249.934C356.313 249.934 356.096 249.999 355.857 250.107L355.879 250.129Z",
    fill: "url(#paint7_linear_3124_5336)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M349.929 236.673C349.386 236.977 348.843 237.346 348.322 237.78C348.539 238.583 349.169 238.908 349.929 238.496C350.689 238.084 351.319 237.042 351.536 236C351.015 236.152 350.472 236.369 349.929 236.673Z",
    fill: "url(#paint8_linear_3124_5336)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M356.508 243.053C356.508 244.16 357.094 244.768 357.854 244.551C357.897 244.052 357.941 243.531 357.941 243.032C357.941 242.012 357.832 241.1 357.637 240.275C356.985 240.948 356.508 242.055 356.508 243.053Z",
    fill: "url(#paint9_linear_3124_5336)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M345.436 258.919C345.588 258.507 345.674 258.051 345.674 257.639C345.674 256.38 344.914 255.772 343.981 256.293C343.699 256.445 343.416 256.705 343.199 257.009C343.785 257.943 344.545 258.594 345.457 258.941L345.436 258.919Z",
    fill: "url(#paint10_linear_3124_5336)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M349.929 256.272C349.126 256.727 348.453 257.856 348.279 258.984C348.822 258.833 349.365 258.616 349.929 258.29C350.494 257.964 351.058 257.595 351.579 257.14C351.406 256.206 350.733 255.816 349.929 256.272Z",
    fill: "url(#paint11_linear_3124_5336)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M343.351 250.845C343.351 249.804 342.851 249.239 342.157 249.326C342.026 250.194 341.939 251.062 341.939 251.909C341.939 252.56 341.983 253.189 342.07 253.775C342.808 253.124 343.351 251.909 343.351 250.845Z",
    fill: "url(#paint12_linear_3124_5336)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M343.98 245.05C344.914 244.529 345.673 243.075 345.673 241.816C345.673 241.469 345.608 241.187 345.521 240.948C344.631 242.25 343.871 243.705 343.285 245.246C343.502 245.246 343.741 245.202 343.98 245.072V245.05Z",
    fill: "url(#paint13_linear_3124_5336)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M313.298 238.314C312.69 240.385 312.132 243.397 312.311 247.195L328.943 254.707C328.952 254.536 328.963 254.337 328.978 254.112C329.035 253.255 329.142 252.023 329.34 250.519C329.737 247.513 330.501 243.414 331.974 239.044C334.917 230.315 340.717 220.427 352.143 216.108L352.143 216.108L352.145 216.107L352.149 216.105L352.165 216.099C352.179 216.094 352.199 216.087 352.224 216.078C352.275 216.06 352.349 216.034 352.444 216.003C352.635 215.94 352.912 215.853 353.26 215.758C353.957 215.566 354.946 215.337 356.117 215.184C357.172 215.047 358.384 214.97 359.669 215.042L354.106 212.556L314.519 235.193C314.507 235.217 314.492 235.245 314.475 235.277C314.404 235.412 314.302 235.618 314.18 235.891C313.935 236.436 313.61 237.251 313.298 238.314Z",
    fill: "#222222",
    stroke: "url(#paint14_linear_3124_5336)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M315.339 245.576C315.339 245.576 323.155 248.81 323.459 260.573L318.14 257.773L310.323 251.523L304.787 248.202L302.334 244.968C305.134 240.28 315.339 245.576 315.339 245.576Z",
    fill: "url(#paint15_linear_3124_5336)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M312.994 247.833L299.164 239.846C298.469 239.303 297.709 238.869 296.928 238.544H296.906C293.801 237.263 290.002 237.61 285.898 239.889C275.411 245.727 266.9 261.962 266.9 276.156C266.9 284.208 269.636 289.873 273.913 292.217H273.892L290.219 301.571L289.936 298.12L286.853 291.196C286.853 291.196 286.745 291.088 286.571 290.914C296.776 284.794 304.918 268.929 304.918 255.017C304.918 253.497 304.809 252.043 304.635 250.698H306.893L313.038 247.811L312.994 247.833Z",
    fill: "#000F20"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M321.353 264.501C321.353 278.696 312.842 294.951 302.355 300.768C291.868 306.606 283.357 299.813 283.357 285.619C283.357 271.425 291.868 255.169 302.355 249.352C312.842 243.514 321.353 250.307 321.353 264.501Z",
    fill: "#222222"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M315.47 267.757C315.47 277.567 309.586 288.788 302.356 292.803C295.104 296.84 289.242 292.152 289.242 282.342C289.242 272.532 295.126 261.311 302.356 257.296C309.608 253.259 315.47 257.947 315.47 267.757Z",
    fill: "url(#paint16_linear_3124_5336)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M313.016 269.124C313.016 277.09 308.24 286.205 302.356 289.482C296.472 292.76 291.695 288.94 291.695 280.975C291.695 273.009 296.472 263.894 302.356 260.617C308.24 257.339 313.016 261.159 313.016 269.124Z",
    fill: "#000F20"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M311.453 269.992C311.453 276.807 307.371 284.576 302.334 287.376C297.297 290.176 293.215 286.92 293.215 280.105C293.215 273.291 297.297 265.521 302.334 262.721C307.371 259.921 311.453 263.177 311.453 269.992Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M308.88 277.718C311.44 271.422 310.598 265.132 306.999 263.67C303.4 262.207 298.407 266.126 295.846 272.422C293.286 278.718 294.129 285.008 297.728 286.47C301.327 287.933 306.32 284.014 308.88 277.718Z",
    fill: "#222222"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M305.655 273.204C305.655 275.678 304.179 278.5 302.355 279.52C300.531 280.54 299.055 279.346 299.055 276.872C299.055 274.398 300.531 271.576 302.355 270.556C304.179 269.536 305.655 270.73 305.655 273.204Z",
    fill: "#D7F0FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M306.48 273.79C306.48 276.134 305.069 278.825 303.332 279.78C301.595 280.735 300.184 279.628 300.184 277.284C300.184 274.94 301.595 272.249 303.332 271.294C305.069 270.339 306.48 271.446 306.48 273.79Z",
    fill: "url(#paint17_linear_3124_5336)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M308.912 266.064C309.042 265.998 309.151 265.912 309.281 265.803C308.782 264.913 308.13 264.24 307.349 263.828C307.284 264.11 307.24 264.414 307.24 264.696C307.24 265.955 308 266.563 308.934 266.042L308.912 266.064Z",
    fill: "url(#paint18_linear_3124_5336)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M308.305 277.696C307.371 278.217 306.611 279.671 306.611 280.93C306.611 281.212 306.655 281.473 306.72 281.668C307.588 280.409 308.348 278.999 308.934 277.501C308.739 277.501 308.522 277.566 308.283 277.675L308.305 277.696Z",
    fill: "url(#paint19_linear_3124_5336)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M302.355 264.24C301.812 264.544 301.269 264.913 300.748 265.347C300.965 266.15 301.595 266.476 302.355 266.063C303.115 265.651 303.744 264.609 303.961 263.567C303.44 263.719 302.897 263.936 302.355 264.24Z",
    fill: "url(#paint20_linear_3124_5336)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M308.912 270.621C308.912 271.728 309.498 272.335 310.258 272.118C310.302 271.619 310.345 271.098 310.345 270.599C310.345 269.579 310.237 268.668 310.041 267.843C309.39 268.516 308.912 269.622 308.912 270.621Z",
    fill: "url(#paint21_linear_3124_5336)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M297.84 286.487C297.992 286.074 298.079 285.618 298.079 285.206C298.079 283.947 297.319 283.34 296.385 283.86C296.103 284.012 295.821 284.273 295.604 284.577C296.19 285.51 296.95 286.161 297.861 286.508L297.84 286.487Z",
    fill: "url(#paint22_linear_3124_5336)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M302.355 283.839C301.552 284.295 300.879 285.423 300.705 286.552C301.248 286.4 301.791 286.183 302.355 285.857C302.92 285.532 303.484 285.163 304.005 284.707C303.832 283.774 303.159 283.383 302.355 283.839Z",
    fill: "url(#paint23_linear_3124_5336)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M295.776 278.413C295.776 277.371 295.277 276.807 294.582 276.893C294.452 277.762 294.365 278.63 294.365 279.476C294.365 280.127 294.409 280.757 294.495 281.343C295.234 280.692 295.776 279.476 295.776 278.413Z",
    fill: "url(#paint24_linear_3124_5336)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M296.384 272.618C297.318 272.097 298.078 270.643 298.078 269.384C298.078 269.037 298.013 268.754 297.926 268.516C297.036 269.818 296.276 271.272 295.689 272.813C295.907 272.813 296.145 272.77 296.384 272.639V272.618Z",
    fill: "url(#paint25_linear_3124_5336)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M263.294 267.314C262.686 269.385 262.128 272.397 262.307 276.195L278.939 283.707C278.948 283.536 278.959 283.337 278.974 283.112C279.031 282.255 279.138 281.023 279.336 279.519C279.733 276.513 280.497 272.414 281.97 268.044C284.913 259.315 290.713 249.427 302.139 245.108L302.139 245.108L302.141 245.107L302.145 245.105L302.161 245.099C302.175 245.094 302.195 245.087 302.22 245.078C302.271 245.06 302.345 245.034 302.44 245.003C302.631 244.94 302.908 244.853 303.256 244.758C303.953 244.566 304.942 244.337 306.113 244.184C307.168 244.047 308.38 243.97 309.665 244.042L304.102 241.556L264.516 264.193C264.503 264.217 264.488 264.245 264.471 264.277C264.4 264.412 264.298 264.618 264.176 264.891C263.931 265.436 263.606 266.251 263.294 267.314Z",
    fill: "#222222",
    stroke: "url(#paint26_linear_3124_5336)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M417.338 60.9486V173.385L187.354 304.843V192.407L417.338 60.9486Z",
    fill: "#222222",
    stroke: "url(#paint27_linear_3124_5336)",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M416.169 62.9624V172.717L188.501 302.83V193.075L416.169 62.9407M420.338 55.7568L184.332 190.644V309.992L420.338 175.105V55.7785V55.7568Z",
    fill: "#222222"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M184.357 187.103L92.377 134.501L322.308 3.45441L414.266 56.0347L184.357 187.103Z",
    fill: "#222222",
    stroke: "url(#paint28_linear_3124_5336)",
    strokeWidth: 6
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M322.31 4.79649L411.936 56.0386L184.354 185.761L94.7283 134.519L322.31 4.79649ZM322.31 0L86.3477 134.497L184.354 190.536L420.317 56.0386L322.31 0Z",
    fill: "#222222"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M181.354 192.298V304.82L89.3262 252.191V139.669L181.354 192.298Z",
    fill: "#222222",
    stroke: "url(#paint29_linear_3124_5336)",
    strokeWidth: 6
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4948 141.681L180.186 192.988V302.83L90.4948 251.523V141.681ZM86.3262 134.497V253.932L184.333 309.992V190.557L86.3262 134.497Z",
    fill: "#222222"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9203 270.861L26.2715 272.554V234.269L28.9203 232.576V270.861Z",
    fill: "url(#paint30_linear_3124_5336)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2712 234.247L11.377 225.913L14.0258 224.307L28.8983 232.641L26.2712 234.247Z",
    fill: "url(#paint31_linear_3124_5336)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2712 272.554L11.377 264.22V225.913L26.2712 234.247V272.554Z",
    fill: "#001E1A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M109.708 266.399L23.0863 216.861L90.6676 178.111L177.268 227.649L109.708 266.399Z",
    fill: "url(#paint32_linear_3124_5336)",
    stroke: "#222222"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M174.171 348.125L166.615 344.523L152.589 334.908L142.363 327.659V322.19L164.9 310.014L176.168 307.757V313.204",
    fill: "#000508"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M163.25 333.411L149.42 325.424C148.725 324.881 147.965 324.447 147.183 324.122H147.162C144.057 322.841 140.257 323.189 136.154 325.467C125.667 331.306 117.156 347.54 117.156 361.734C117.156 369.786 119.892 375.451 124.169 377.795H124.147L140.475 387.149L140.192 383.698L137.109 376.775C137.109 376.775 137.001 376.666 136.827 376.492C147.032 370.372 155.173 354.507 155.173 340.595C155.173 339.075 155.065 337.621 154.891 336.276H157.149L163.294 333.389L163.25 333.411Z",
    fill: "#000F20"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M163.429 334.05C167.468 335.691 170.05 340.08 170.848 346.035C171.644 351.974 170.644 359.361 167.63 366.774C164.615 374.187 160.176 380.177 155.461 383.877C150.733 387.586 145.82 388.931 141.781 387.29C137.742 385.648 135.161 381.259 134.363 375.304C133.566 369.365 134.567 361.978 137.581 354.565C140.595 347.152 145.034 341.162 149.75 337.463C154.478 333.753 159.39 332.409 163.429 334.05Z",
    fill: "#222222",
    stroke: "url(#paint33_linear_3124_5336)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M165.726 353.334C165.726 363.144 159.842 374.365 152.612 378.38C145.36 382.417 139.498 377.729 139.498 367.919C139.498 358.109 145.382 346.888 152.612 342.873C159.864 338.836 165.726 343.524 165.726 353.334Z",
    fill: "url(#paint34_linear_3124_5336)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M163.272 354.702C163.272 362.667 158.495 371.782 152.612 375.06C146.728 378.337 141.951 374.517 141.951 366.552C141.951 358.587 146.728 349.471 152.612 346.194C158.495 342.917 163.272 346.736 163.272 354.702Z",
    fill: "#000F20"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M161.709 355.57C161.709 362.385 157.627 370.155 152.59 372.954C147.552 375.754 143.471 372.499 143.471 365.684C143.471 358.869 147.552 351.099 152.59 348.299C157.627 345.499 161.709 348.755 161.709 355.57Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M160.601 356.199C160.601 362.167 157.018 369.004 152.611 371.457C148.204 373.909 144.621 371.066 144.621 365.076C144.621 359.086 148.204 352.271 152.611 349.818C157.018 347.366 160.601 350.209 160.601 356.199Z",
    fill: "#222222"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M155.911 358.804C155.911 361.278 154.434 364.099 152.611 365.119C150.787 366.139 149.311 364.946 149.311 362.472C149.311 359.997 150.787 357.176 152.611 356.156C154.434 355.136 155.911 356.33 155.911 358.804Z",
    fill: "#D7F0FF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M156.714 359.389C156.714 361.733 155.303 364.425 153.566 365.38C151.829 366.335 150.418 365.228 150.418 362.884C150.418 360.54 151.829 357.848 153.566 356.894C155.303 355.939 156.714 357.045 156.714 359.389Z",
    fill: "url(#paint35_linear_3124_5336)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M159.168 351.642C159.298 351.577 159.407 351.49 159.537 351.381C159.038 350.491 158.386 349.819 157.605 349.406C157.539 349.688 157.496 349.992 157.496 350.274C157.496 351.533 158.256 352.141 159.19 351.62L159.168 351.642Z",
    fill: "url(#paint36_linear_3124_5336)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M158.539 363.274C157.606 363.795 156.846 365.249 156.846 366.508C156.846 366.79 156.889 367.051 156.954 367.246C157.823 365.987 158.583 364.577 159.169 363.079C158.973 363.079 158.756 363.144 158.517 363.253L158.539 363.274Z",
    fill: "url(#paint37_linear_3124_5336)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M152.589 349.818C152.046 350.122 151.504 350.491 150.982 350.925C151.2 351.728 151.829 352.054 152.589 351.641C153.349 351.229 153.979 350.187 154.196 349.146C153.675 349.297 153.132 349.514 152.589 349.818Z",
    fill: "url(#paint38_linear_3124_5336)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M159.168 356.199C159.168 357.306 159.754 357.914 160.514 357.697C160.558 357.197 160.601 356.676 160.601 356.177C160.601 355.157 160.492 354.246 160.297 353.421C159.646 354.094 159.168 355.201 159.168 356.199Z",
    fill: "url(#paint39_linear_3124_5336)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M148.096 372.065C148.248 371.652 148.334 371.197 148.334 370.784C148.334 369.525 147.575 368.918 146.641 369.439C146.359 369.591 146.076 369.851 145.859 370.155C146.446 371.088 147.205 371.739 148.117 372.086L148.096 372.065Z",
    fill: "url(#paint40_linear_3124_5336)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M152.589 369.439C151.786 369.894 151.113 371.023 150.939 372.151C151.482 372 152.025 371.782 152.589 371.457C153.154 371.131 153.719 370.762 154.24 370.307C154.066 369.373 153.393 368.983 152.589 369.439Z",
    fill: "url(#paint41_linear_3124_5336)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M146.011 364.012C146.011 362.971 145.512 362.406 144.817 362.493C144.686 363.361 144.6 364.229 144.6 365.076C144.6 365.727 144.643 366.356 144.73 366.942C145.468 366.291 146.011 365.076 146.011 364.012Z",
    fill: "url(#paint42_linear_3124_5336)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M146.619 358.217C147.552 357.696 148.312 356.242 148.312 354.983C148.312 354.636 148.247 354.354 148.16 354.115C147.27 355.417 146.51 356.872 145.924 358.413C146.141 358.413 146.38 358.369 146.619 358.239V358.217Z",
    fill: "url(#paint43_linear_3124_5336)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M146.62 325.38L164.249 316.351L174.172 328.028V348.125L178.297 345.759V227.432L109.688 267.106L89.4961 315.374L94.0773 394.158L128.425 374.452C131.269 343.35 146.62 325.423 146.62 325.423V325.38Z",
    fill: "#D0E1EE"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M143.274 310.773L156.258 304.11C162.533 301.398 166.615 295.234 166.615 288.397V245.402L116.07 274.615L106.669 313.204L104.562 356.872L126.079 344.522C131.572 325.727 143.274 310.773 143.274 310.773Z",
    fill: "#B1C8DA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M121.781 274.984L113.292 309.84L112.814 319.216L153.328 295.95V256.905L121.781 274.984Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M151.939 295.277V259.162L122.781 275.874L114.639 309.297L114.27 316.915L151.939 295.277Z",
    fill: "#161C21"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 321.364L8.66294 316.828V320.344L8.31558 322.276L6.03585 323.556",
    fill: "url(#paint44_linear_3124_5336)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0991 382.46L6.4707 332.347C6.4707 332.347 6.97007 289.829 8.8807 275.679C10.8782 260.985 22.0814 216.884 22.0814 216.884L109.71 266.997C109.71 266.997 99.3967 304.501 97.7032 317.002C95.4886 333.367 94.0991 382.46 94.0991 382.46Z",
    fill: "#B1C8DA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4424 330.61C96.8333 325.163 97.2457 320.388 97.7017 317.002C99.3952 304.501 109.708 266.997 109.708 266.997L22.0799 216.884C22.0799 216.884 10.8767 260.985 8.87919 275.679C8.66208 277.22 8.48837 279.086 8.29297 281.213L96.4207 330.632L96.4424 330.61Z",
    fill: "#161C21"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66211 281.386L96.6596 327.658L100.177 295.624L38.1466 263.633L8.66211 280.692V281.386Z",
    fill: "#0F101B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0799 216.862C22.0799 216.862 10.8767 260.964 8.87919 275.657C8.66208 277.198 8.48837 279.065 8.29297 281.192L96.4207 330.611C96.8115 325.163 97.2241 320.388 97.68 317.003C99.3735 304.501 109.687 266.998 109.687 266.998L22.0582 216.884L22.0799 216.862ZM94.7489 316.59C94.445 318.891 94.1193 321.951 93.8153 325.727L11.4412 279.542C11.5714 278.218 11.7017 277.046 11.832 276.07C13.4387 264.219 21.2549 232.402 24.0122 221.42L106.234 268.452C103.976 276.786 96.2253 305.695 94.7489 316.634V316.59Z",
    fill: "url(#paint45_linear_3124_5336)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2129 393.898L93.665 395.765L119.676 376.861L123.149 357.762L119.676 355.917L90.2129 372.954V393.898Z",
    fill: "url(#paint46_linear_3124_5336)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1381 393.746L93.686 395.894L3.47385 340.463L0 321.364L3.47385 319.52L97.1598 373.084L97.1381 393.746Z",
    fill: "#477FFF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8546 324.316L3.47385 319.52L0 321.386L3.47385 340.485L10.0742 344.544C9.0972 337.902 10.0742 330.849 11.8546 324.338V324.316Z",
    fill: "url(#paint47_linear_3124_5336)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7722 362.015L21.2349 329.677C19.4112 337.49 18.8901 346.454 24.8391 352.422C29.8327 357.436 37.0628 359.845 43.75 361.624C51.5227 363.686 59.5126 367.441 67.6545 367.658C72.4094 367.788 75.8181 365.444 77.7722 362.015Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8689 367.202C84.0029 372.237 79.4001 376.166 73.4511 377.533C70.4983 378.206 67.5021 378.271 64.5059 377.967L93.6864 395.894L97.1385 393.746V373.084L86.8689 367.202Z",
    fill: "#477FFF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1702 358.803L68.6963 360.648L72.1702 363.513L28.4645 338.532V333.8L3.49609 319.52V340.463L93.6865 395.894L97.1603 393.746L98.5499 371.651L93.5561 371.022L72.1702 358.803Z",
    fill: "url(#paint48_linear_3124_5336)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6958 360.648V365.379L24.9901 340.377V335.667L0 321.364V342.308L93.686 395.894V374.95L68.6958 360.648Z",
    fill: "#222222"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4641 333.801L24.9902 335.667V340.377L28.4641 338.532V333.801Z",
    fill: "#93D7FF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2467 212.847L55.1914 227.345V221.181L80.2467 211.35V212.847Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1917 221.159L46.3984 216.081L71.4537 206.336L80.247 211.415L55.1917 221.159Z",
    fill: "#222222"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1917 227.345L46.3984 222.267V216.081L55.1917 221.16V227.345Z",
    fill: "#222222"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1502 225.63L47.2676 221.702V217.773L54.1502 221.724V225.63Z",
    fill: "url(#paint49_linear_3124_5336)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M104.282 225.87L79.2266 240.368V234.204L104.282 224.372V225.87Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2269 234.182L70.4336 229.103L95.4889 219.358L104.282 224.437L79.2269 234.182Z",
    fill: "#222222"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2269 240.368L70.4336 235.289V229.104L79.2269 234.182V240.368Z",
    fill: "#222222"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1854 238.653L71.3027 234.724V230.796L78.1854 234.746V238.653Z",
    fill: "url(#paint50_linear_3124_5336)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M128.317 238.891L103.262 253.389V247.225L128.317 237.394V238.891Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M103.262 247.203L94.4688 242.125L119.524 232.38L128.317 237.459L103.262 247.203Z",
    fill: "#222222"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M103.262 253.389L94.4688 248.311V242.125L103.262 247.204V253.389Z",
    fill: "#222222"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M102.221 251.674L95.3379 247.746V243.817L102.221 247.767V251.674Z",
    fill: "url(#paint51_linear_3124_5336)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.7878 266.693L89.3216 261.268L50.5879 300.008L60.1193 305.348L98.7878 266.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0656 239.391L16.4572 273.986C16.3486 274.615 16.2618 275.223 16.1966 275.766C16.0229 277.068 15.8492 278.674 15.6973 280.475L41.0782 294.713L79.8988 255.907L51.0439 239.412L51.0656 239.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8539 283.102L70.0195 310.926L74.1013 313.226L95.6828 291.653C96.3993 288.744 97.1374 285.836 97.8322 283.123L97.8539 283.102Z",
    fill: "white"
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M85.044 362.471L16.1094 323.036V296.883L85.044 336.318V362.471Z",
    fill: "#222222"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5625 321.365L81.5928 356.85V353.009L19.5625 317.524V321.365ZM19.5625 302.526V306.368L81.5928 341.853V338.012L19.5625 302.526ZM19.5625 313.877L81.5928 349.363V345.521L19.5625 310.036V313.877Z",
    fill: "url(#paint52_linear_3124_5336)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6641 395.765L123.149 378.706V357.762L93.6641 374.821V395.765Z",
    fill: "#222222"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M135.741 324.642L133.092 326.356V288.071L135.741 286.356V324.642Z",
    fill: "url(#paint53_linear_3124_5336)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M133.093 288.028L118.221 279.694L120.87 278.109L135.742 286.422L133.093 288.028Z",
    fill: "url(#paint54_linear_3124_5336)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M133.093 326.356L118.221 318.022V279.693L133.093 288.028V326.356Z",
    fill: "#001208"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M126.514 326.075C126.384 326.075 126.232 326.031 126.101 325.966L104.607 313.921C104.216 313.704 104.064 313.183 104.281 312.792C104.498 312.401 105.019 312.25 105.41 312.467L125.667 323.817V321.365C125.667 320.909 126.036 320.54 126.492 320.54C126.948 320.54 127.317 320.909 127.317 321.365V325.25C127.317 325.554 127.165 325.814 126.905 325.966C126.774 326.031 126.622 326.075 126.492 326.075H126.514Z",
    fill: "#001208"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M126.514 283.904C126.058 283.904 125.689 283.535 125.689 283.079V279.173L114.269 272.77C113.878 272.553 113.726 272.032 113.943 271.642C114.16 271.251 114.681 271.099 115.072 271.316L126.927 277.957C127.187 278.109 127.361 278.391 127.361 278.674V283.079C127.361 283.535 126.992 283.904 126.536 283.904H126.514Z",
    fill: "#001208"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3107 370.74C78.3349 369.633 76.0117 369.655 74.0794 370.805C72.147 371.934 70.9746 373.974 70.9746 376.209V376.426L89.8855 387.018V376.101L80.3107 370.74Z",
    fill: "url(#paint55_linear_3124_5336)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5164 386.388L71.3438 376.209C71.3438 371.695 76.2071 368.852 80.137 371.066L89.5164 376.318V386.388Z",
    fill: "#222222"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5166 391.271L81.5918 386.844V383.675L89.5166 388.102V391.271Z",
    fill: "url(#paint56_linear_3124_5336)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1126 377.555C82.1126 379.66 80.7882 380.615 79.1599 379.66C77.5315 378.705 76.207 376.231 76.207 374.126C76.207 372.02 77.5315 371.065 79.1599 372.02C80.7882 372.975 82.1126 375.45 82.1126 377.555Z",
    fill: "#FFFFFD"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7381 380.442C86.7381 381.636 85.9783 382.178 85.0664 381.636C84.1545 381.093 83.3945 379.682 83.3945 378.489C83.3945 377.295 84.1545 376.752 85.0664 377.295C86 377.837 86.7381 379.248 86.7381 380.442Z",
    fill: "#FFFFFD"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3341 330.523C9.35832 329.416 1.99805 325.119 1.99805 325.119V336.21L20.9089 346.801V345.716C20.9089 339.639 17.6305 334.039 12.3111 331.066L11.3341 330.523Z",
    fill: "url(#paint57_linear_3124_5336)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5399 346.171L2.36719 335.992V325.922L11.7466 331.174C17.1745 334.213 20.5399 339.942 20.5399 346.171Z",
    fill: "#222222"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4226 345.846L2.51953 341.418V338.271L10.4226 342.699V345.846Z",
    fill: "url(#paint58_linear_3124_5336)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2493 335.515C10.2493 337.62 8.92492 338.575 7.29654 337.62C5.66816 336.665 4.34375 334.191 4.34375 332.086C4.34375 329.98 5.66816 329.025 7.29654 329.98C8.92492 330.935 10.2493 333.41 10.2493 335.515Z",
    fill: "#FFFFFD"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2205 338.966C15.2205 340.16 14.4606 340.703 13.5487 340.16C12.6151 339.617 11.877 338.207 11.877 337.013C11.877 335.819 12.6368 335.277 13.5487 335.819C14.4606 336.362 15.2205 337.773 15.2205 338.966Z",
    fill: "#FFFFFD"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M143.535 305.824L152.567 300.898V298.163L143.535 303.068V305.824Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M194.66 106.696L200.557 103.317L224.733 117.578C227.129 119.002 228.601 118.936 230.622 117.788L231.265 117.423L236.319 120.403L235.369 120.958C230.053 124.013 224.046 124.05 219.036 121.087L194.674 106.712L194.66 106.696Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M240.961 110.238L244.744 108.076C247.945 106.238 249.818 103.762 250.025 101.105C250.993 101.84 251.72 102.622 252.209 103.435C251.345 105.641 249.438 107.655 246.697 109.223L242.929 111.385C242.071 111.871 241.43 112.473 241.051 113.149C240.74 113.68 240.619 114.252 240.677 114.819C239.781 114.932 238.887 115.001 237.996 115.025C237.879 114.203 238.042 113.397 238.486 112.621C238.981 111.714 239.842 110.902 240.991 110.24L240.961 110.238Z",
    fill: "#161616"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M251.721 104.462C251.918 104.117 252.07 103.784 252.207 103.451C252.82 104.434 253.075 105.441 253.004 106.461C252.844 108.528 251.26 110.604 248.228 112.333C247.953 112.481 247.693 112.63 247.418 112.763C245.327 113.833 243.021 114.505 240.676 114.819C240.669 114.685 240.662 114.537 240.669 114.404C240.678 114.256 240.685 114.123 240.722 113.991C240.742 113.903 240.76 113.845 240.779 113.772C240.798 113.684 240.831 113.627 240.849 113.568C240.884 113.481 240.902 113.423 240.935 113.366C240.935 113.366 240.936 113.336 240.952 113.322C240.985 113.265 241.018 113.207 241.051 113.135C241.43 112.459 242.072 111.857 242.929 111.371L246.697 109.208C246.789 109.154 246.881 109.1 246.973 109.046C247.003 109.033 247.035 109.005 247.065 108.992C247.127 108.951 247.173 108.923 247.234 108.882C247.265 108.855 247.311 108.842 247.342 108.814C247.388 108.787 247.449 108.746 247.495 108.719C247.527 108.691 247.572 108.664 247.603 108.651C247.649 108.624 247.696 108.582 247.742 108.555C247.788 108.528 247.819 108.5 247.85 108.472C247.896 108.445 247.942 108.418 247.974 108.375C248.02 108.348 248.051 108.32 248.097 108.293C248.143 108.266 248.175 108.238 248.22 108.211C248.266 108.184 248.298 108.156 248.329 108.128C248.375 108.101 248.406 108.073 248.453 108.031C248.484 108.003 248.53 107.976 248.561 107.948C248.607 107.921 248.639 107.893 248.685 107.851C248.717 107.823 248.763 107.796 248.794 107.768C248.825 107.74 248.871 107.713 248.903 107.671C248.98 107.616 249.043 107.545 249.121 107.49C249.152 107.462 249.183 107.434 249.214 107.406C249.261 107.364 249.292 107.336 249.339 107.294C249.37 107.267 249.402 107.239 249.432 107.225C249.479 107.184 249.51 107.156 249.557 107.114C249.588 107.086 249.619 107.058 249.635 107.044C249.667 107.001 249.713 106.974 249.745 106.932C249.776 106.904 249.792 106.875 249.824 106.847C249.856 106.804 249.902 106.777 249.934 106.734C249.965 106.707 249.981 106.678 250.012 106.665C250.044 106.622 250.091 106.58 250.122 106.552C250.138 106.523 250.169 106.51 250.185 106.482C250.217 106.439 250.264 106.397 250.296 106.354C250.312 106.34 250.328 106.312 250.344 106.298C250.39 106.256 250.422 106.213 250.47 106.156C250.47 106.156 250.487 106.128 250.502 106.114C250.707 105.888 250.884 105.646 251.061 105.403C251.061 105.403 251.061 105.389 251.077 105.375C251.11 105.317 251.157 105.275 251.19 105.218C251.19 105.203 251.206 105.189 251.222 105.175C251.254 105.118 251.287 105.075 251.319 105.017C251.32 105.003 251.336 104.989 251.351 104.975C251.384 104.917 251.416 104.875 251.449 104.817C251.45 104.802 251.466 104.788 251.481 104.774C251.514 104.717 251.546 104.674 251.579 104.617C251.579 104.617 251.581 104.587 251.596 104.573C251.629 104.516 251.662 104.458 251.695 104.401L251.721 104.462Z",
    fill: "url(#paint59_linear_3124_5336)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M244.337 102.049C244.792 100.799 244.702 99.4892 244.104 98.24C245.185 98.5374 246.23 98.9367 247.241 99.423C247.495 100.712 247.29 102.006 246.643 103.23C245.898 104.642 244.582 105.903 242.805 106.931L239.022 109.093C237.643 109.891 236.58 110.869 235.942 111.946C235.385 112.894 235.151 113.904 235.257 114.918C234.343 114.823 233.433 114.668 232.54 114.455C232.515 113.312 232.86 112.175 233.527 111.115C234.32 109.913 235.507 108.838 237.069 107.946L240.852 105.784C242.614 104.77 243.827 103.488 244.351 102.064L244.337 102.049Z",
    fill: "#161616"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M222.766 106.008C222.926 103.941 224.495 101.863 227.557 100.121C227.803 99.9715 228.077 99.8385 228.337 99.7047C229.466 99.13 230.663 98.6629 231.884 98.3156L232.96 98.9539C232.96 98.9539 233.032 99.0023 233.061 99.0188C233.075 99.0196 233.103 99.0508 233.118 99.0516C233.118 99.0516 233.148 99.0533 233.147 99.068C233.175 99.0845 233.204 99.1009 233.232 99.1321C233.232 99.1321 233.247 99.1329 233.261 99.1485C233.276 99.1494 233.289 99.1797 233.304 99.1806C233.304 99.1806 233.318 99.1962 233.331 99.2118C233.331 99.2118 233.359 99.243 233.374 99.2438C233.374 99.2438 233.388 99.2594 233.402 99.275C233.402 99.275 233.43 99.3062 233.445 99.307C233.445 99.307 233.459 99.3227 233.473 99.3383L233.501 99.3695C233.501 99.3695 233.515 99.3851 233.529 99.4007C233.529 99.4007 233.542 99.4311 233.556 99.4319C233.556 99.4319 233.57 99.4475 233.584 99.4631C233.584 99.4631 233.598 99.4935 233.612 99.4943C233.612 99.4943 233.626 99.5099 233.64 99.5255C233.64 99.5255 233.653 99.5559 233.668 99.5567C233.668 99.5567 233.667 99.5715 233.681 99.5871C233.681 99.5871 233.68 99.6167 233.694 99.6175C233.694 99.6175 233.693 99.6471 233.708 99.6479C233.708 99.6479 233.706 99.6775 233.72 99.6931C233.72 99.6931 233.719 99.7078 233.733 99.7235C233.733 99.7235 233.731 99.753 233.745 99.7686C233.745 99.7686 233.744 99.7834 233.744 99.7982C233.744 99.7982 233.742 99.8277 233.741 99.8425C233.741 99.8425 233.74 99.8573 233.74 99.8721C233.739 99.8869 233.738 99.9017 233.737 99.9164C233.737 99.9164 233.736 99.9312 233.735 99.946C233.734 99.9756 233.733 99.9903 233.731 100.02C233.753 100.436 233.478 100.836 232.973 101.119L229.205 103.282C229.113 103.336 229.037 103.376 228.945 103.431C228.914 103.444 228.883 103.472 228.853 103.485C228.792 103.511 228.745 103.553 228.684 103.579C228.653 103.607 228.623 103.62 228.577 103.647C228.531 103.675 228.485 103.702 228.423 103.743C228.392 103.771 228.347 103.783 228.316 103.811C228.27 103.838 228.224 103.865 228.177 103.907C228.146 103.935 228.115 103.948 228.069 103.975C228.023 104.002 227.977 104.029 227.931 104.071C227.899 104.099 227.854 104.111 227.823 104.139C227.777 104.166 227.731 104.193 227.684 104.235C227.653 104.263 227.623 104.276 227.577 104.303C227.531 104.331 227.485 104.358 227.438 104.4C227.407 104.427 227.376 104.441 227.345 104.469C227.299 104.496 227.252 104.537 227.206 104.565C227.175 104.592 227.145 104.606 227.113 104.634C227.067 104.675 227.021 104.703 226.974 104.744C226.943 104.758 226.912 104.785 226.897 104.799C226.819 104.854 226.757 104.91 226.68 104.965C226.649 104.978 226.633 105.007 226.602 105.02C226.556 105.062 226.51 105.089 226.463 105.131C226.432 105.159 226.4 105.187 226.369 105.215C226.338 105.243 226.292 105.27 226.261 105.298C226.23 105.326 226.198 105.354 226.152 105.381C226.121 105.409 226.09 105.437 226.044 105.464C226.013 105.492 225.982 105.52 225.95 105.547C225.919 105.575 225.888 105.603 225.857 105.631C225.826 105.659 225.794 105.687 225.763 105.715C225.732 105.743 225.701 105.771 225.669 105.799C225.638 105.827 225.607 105.855 225.575 105.897C225.544 105.925 225.513 105.953 225.481 105.981C225.45 106.009 225.419 106.037 225.388 106.065C225.357 106.093 225.325 106.121 225.294 106.148C225.263 106.176 225.232 106.204 225.201 106.232C225.169 106.26 225.138 106.288 225.107 106.316C225.076 106.344 225.044 106.372 225.012 106.415C224.981 106.442 224.965 106.471 224.934 106.499C224.87 106.57 224.807 106.64 224.745 106.696C224.713 106.724 224.697 106.753 224.667 106.766C224.635 106.794 224.603 106.837 224.572 106.864C224.541 106.892 224.525 106.921 224.493 106.949C224.462 106.977 224.43 107.02 224.414 107.048C224.382 107.076 224.366 107.105 224.335 107.133C224.304 107.161 224.286 107.204 224.255 107.232C224.224 107.26 224.208 107.289 224.175 107.332C224.144 107.36 224.127 107.403 224.096 107.431C224.065 107.459 224.048 107.488 224.017 107.516C223.986 107.544 223.969 107.587 223.937 107.615C223.921 107.644 223.89 107.672 223.873 107.7C223.842 107.728 223.825 107.772 223.794 107.8C223.777 107.829 223.746 107.856 223.729 107.9C223.697 107.928 223.68 107.971 223.649 107.999C223.633 108.028 223.601 108.071 223.584 108.099C223.568 108.128 223.536 108.171 223.519 108.2C223.503 108.228 223.471 108.271 223.454 108.3C223.438 108.329 223.406 108.371 223.389 108.4C223.357 108.458 223.325 108.5 223.292 108.558C223.292 108.558 223.291 108.572 223.275 108.586C222.82 107.716 222.617 106.83 222.682 105.929L222.766 106.008Z",
    fill: "url(#paint60_linear_3124_5336)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M235.043 98.0017C234.958 97.9376 234.9 97.9048 234.843 97.8719L234.584 97.724C235.602 97.5583 236.629 97.482 237.654 97.4501C237.853 97.6095 238.021 97.7819 238.175 97.9388C238.231 98.0012 238.273 98.0481 238.329 98.1105C238.482 98.2821 238.605 98.4669 238.715 98.6361C238.755 98.7125 238.797 98.7593 238.823 98.8201C238.89 98.9424 238.943 99.064 238.995 99.1855C239.021 99.2611 239.047 99.3219 239.06 99.367C239.085 99.4426 239.096 99.5025 239.123 99.5633C239.134 99.6233 239.146 99.6832 239.157 99.7432C239.168 99.8179 239.179 99.8779 239.192 99.923C239.187 100.012 239.199 100.057 239.211 100.117C239.206 100.206 239.202 100.265 239.199 100.324C239.162 101.523 238.344 102.634 236.919 103.459L233.166 105.622C233.059 105.676 232.966 105.745 232.859 105.798C232.829 105.811 232.798 105.839 232.767 105.852C232.691 105.893 232.629 105.934 232.553 105.974C232.522 106.002 232.491 106.015 232.46 106.043C232.399 106.084 232.337 106.125 232.275 106.166C232.244 106.194 232.199 106.206 232.168 106.234C232.106 106.275 232.045 106.316 231.998 106.358C231.967 106.386 231.921 106.413 231.89 106.426C231.829 106.467 231.782 106.509 231.72 106.55C231.689 106.578 231.643 106.605 231.612 106.633C231.565 106.675 231.503 106.716 231.457 106.758C231.425 106.786 231.379 106.813 231.348 106.841C231.301 106.883 231.24 106.924 231.193 106.966C231.162 106.994 231.13 107.022 231.084 107.049C231.038 107.09 230.976 107.132 230.929 107.173C230.898 107.201 230.867 107.229 230.836 107.257C230.789 107.299 230.742 107.341 230.68 107.382C230.649 107.41 230.618 107.438 230.587 107.466C230.54 107.508 230.493 107.549 230.446 107.591C230.415 107.619 230.384 107.647 230.353 107.675C230.306 107.717 230.259 107.759 230.212 107.801C230.181 107.829 230.15 107.857 230.119 107.884C230.072 107.926 230.025 107.968 229.977 108.025C229.946 108.053 229.93 108.082 229.899 108.095C229.852 108.151 229.805 108.193 229.757 108.25C229.741 108.279 229.71 108.292 229.694 108.32C229.632 108.376 229.584 108.433 229.521 108.504C229.521 108.504 229.489 108.532 229.489 108.546C229.362 108.688 229.22 108.843 229.108 109C229.107 109.014 229.076 109.027 229.076 109.042C229.028 109.099 228.98 109.156 228.933 109.212C228.916 109.241 228.901 109.255 228.884 109.284C228.851 109.341 228.804 109.383 228.772 109.441C228.755 109.469 228.724 109.497 228.708 109.526C228.676 109.569 228.643 109.626 228.611 109.669C228.594 109.698 228.562 109.74 228.546 109.769C228.514 109.812 228.482 109.854 228.45 109.897C228.433 109.926 228.401 109.969 228.385 109.997C228.353 110.04 228.335 110.084 228.303 110.126C228.287 110.155 228.255 110.198 228.239 110.226C228.207 110.269 228.189 110.313 228.157 110.355C228.141 110.384 228.124 110.428 228.092 110.455C228.075 110.499 228.043 110.542 228.026 110.585C228.009 110.614 227.992 110.657 227.976 110.686C227.958 110.73 227.926 110.772 227.909 110.816C227.893 110.845 227.875 110.888 227.859 110.917C227.842 110.96 227.825 111.004 227.793 111.047C227.79 111.091 227.759 111.119 227.742 111.163C227.724 111.206 227.707 111.25 227.69 111.293C227.687 111.337 227.656 111.365 227.639 111.409C227.622 111.452 227.604 111.496 227.587 111.539C227.585 111.584 227.553 111.612 227.551 111.656C227.549 111.7 227.516 111.758 227.498 111.801C227.497 111.831 227.48 111.874 227.463 111.903C227.46 111.962 227.428 112.005 227.41 112.063C227.408 112.093 227.392 112.122 227.374 112.165C227.355 112.238 227.337 112.311 227.319 112.37C227.273 112.382 227.23 112.365 227.201 112.348C226.985 112.232 226.785 112.103 226.57 111.957C225.998 111.584 225.5 111.201 225.063 110.806C225.319 110.197 225.633 109.622 226.02 109.065C226.068 108.993 226.117 108.922 226.164 108.865C226.228 108.78 226.277 108.709 226.31 108.651C226.31 108.651 226.326 108.622 226.342 108.608C226.389 108.552 226.422 108.494 226.47 108.438C226.471 108.423 226.486 108.409 226.502 108.395C226.55 108.338 226.582 108.281 226.63 108.224C226.631 108.209 226.661 108.196 226.662 108.181C226.71 108.125 226.757 108.068 226.804 108.026C226.805 108.011 226.835 107.998 226.836 107.983C226.884 107.927 226.931 107.87 226.978 107.828C226.979 107.813 227.009 107.8 227.025 107.786C227.073 107.73 227.12 107.673 227.167 107.631C227.167 107.631 227.184 107.602 227.198 107.603C227.246 107.547 227.308 107.491 227.356 107.434C227.607 107.181 227.858 106.943 228.123 106.706C228.139 106.692 228.17 106.664 228.186 106.65C228.232 106.608 228.279 106.566 228.326 106.524C228.357 106.496 228.388 106.483 228.404 106.455C228.451 106.413 228.497 106.386 228.544 106.344C228.575 106.316 228.606 106.288 228.637 106.26C228.684 106.218 228.73 106.191 228.762 106.148C228.793 106.12 228.839 106.093 228.871 106.065C228.917 106.038 228.963 105.996 228.995 105.968C229.041 105.941 229.072 105.913 229.118 105.886C229.164 105.859 229.211 105.817 229.242 105.789C229.288 105.762 229.319 105.734 229.366 105.693C229.412 105.665 229.459 105.624 229.49 105.596C229.536 105.569 229.583 105.527 229.629 105.5C229.675 105.472 229.706 105.445 229.752 105.417C229.798 105.39 229.845 105.349 229.891 105.321C229.937 105.294 229.968 105.266 230.014 105.239C230.06 105.212 230.121 105.171 230.167 105.144C230.213 105.117 230.245 105.089 230.291 105.062C230.352 105.021 230.398 104.994 230.46 104.953C230.506 104.926 230.537 104.898 230.582 104.885C230.644 104.844 230.705 104.818 230.766 104.777C230.797 104.749 230.828 104.736 230.874 104.709C230.966 104.655 231.072 104.601 231.164 104.547L234.918 102.384C235.913 101.816 236.462 101.017 236.449 100.185C236.451 100.141 236.455 100.082 236.442 100.037C236.443 100.022 236.444 100.007 236.445 99.9777C236.447 99.9481 236.449 99.9186 236.436 99.8882C236.436 99.8734 236.438 99.8439 236.424 99.8282C236.426 99.7987 236.413 99.7683 236.4 99.7379C236.4 99.7231 236.387 99.6927 236.373 99.6771C236.375 99.6476 236.362 99.6172 236.348 99.6016C236.349 99.5868 236.335 99.5564 236.322 99.5408C236.323 99.5112 236.295 99.48 236.281 99.4644C236.282 99.4496 236.254 99.4184 236.255 99.4036C236.257 99.3741 236.228 99.3577 236.215 99.3273C236.216 99.3125 236.188 99.2813 236.174 99.2657C236.161 99.2353 236.147 99.2197 236.134 99.1893C236.134 99.1745 236.106 99.1433 236.092 99.1277C236.079 99.0973 236.051 99.0809 236.037 99.0505C236.023 99.0349 236.01 99.0045 235.996 98.9889C235.983 98.9585 235.955 98.9421 235.941 98.9117C235.927 98.8961 235.914 98.8657 235.886 98.8493C235.858 98.8181 235.844 98.8025 235.816 98.7713C235.802 98.7556 235.774 98.7244 235.76 98.7088C235.732 98.6776 235.703 98.6612 235.69 98.6308C235.676 98.6152 235.647 98.5988 235.634 98.5684C235.606 98.5372 235.578 98.5208 235.55 98.4895C235.536 98.4739 235.507 98.4575 235.493 98.4419C235.465 98.4107 235.422 98.3787 235.394 98.3622C235.379 98.3614 235.366 98.331 235.352 98.3154C235.295 98.2678 235.252 98.2357 235.195 98.2029C235.18 98.2021 235.152 98.1709 235.138 98.1553C235.11 98.1388 235.067 98.1068 235.038 98.0904L235.043 98.0017Z",
    fill: "url(#paint61_linear_3124_5336)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M232.946 98.9371L231.869 98.2989C232.758 98.0518 233.659 97.8499 234.571 97.708L234.83 97.8558C234.83 97.8558 234.973 97.938 235.03 97.9856C235.931 98.5844 236.452 99.34 236.483 100.113C236.511 100.945 235.962 101.744 234.952 102.311L231.199 104.474C228.182 106.19 226.074 108.37 225.065 110.776C224.303 110.096 223.734 109.382 223.345 108.649C224.629 106.629 226.627 104.828 229.247 103.313L233.015 101.15C233.52 100.867 233.795 100.467 233.773 100.051C233.75 99.664 233.505 99.2796 233.047 98.9872C233.018 98.9708 232.975 98.9388 232.946 98.9223L232.946 98.9371Z",
    fill: "#161616"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M221.272 105.924C221.46 103.622 223.202 101.361 226.464 99.4966C226.74 99.334 227.031 99.1723 227.305 99.0392C230.632 97.3414 234.593 96.5091 238.517 96.5942C242.458 96.6653 246.362 97.6537 249.562 99.552C249.792 99.6834 250.021 99.8296 250.251 99.9758C253.24 101.936 254.653 104.269 254.466 106.557C254.293 108.86 252.537 111.105 249.29 112.971C249.014 113.133 248.724 113.28 248.418 113.441C245.077 115.138 241.145 115.972 237.22 115.902C233.294 115.832 229.407 114.814 226.205 112.931C225.96 112.799 225.746 112.653 225.517 112.507C222.512 110.546 221.114 108.229 221.286 105.94L221.272 105.924ZM231.882 98.3155C230.646 98.6767 229.465 99.1298 228.335 99.7046C228.076 99.8384 227.802 99.9714 227.556 100.121C224.508 101.864 222.925 103.941 222.765 106.008C222.62 108.075 223.869 110.147 226.587 111.929C226.802 112.06 227.002 112.204 227.218 112.32C230.176 114.056 233.64 114.946 237.181 115.01C240.706 115.073 244.291 114.338 247.404 112.747C247.679 112.599 247.954 112.466 248.214 112.318C251.246 110.589 252.83 108.512 252.989 106.445C253.061 105.426 252.806 104.418 252.193 103.435C251.704 102.637 250.976 101.855 250.01 101.104C249.74 100.896 249.469 100.703 249.168 100.509C248.953 100.378 248.753 100.248 248.537 100.118C248.106 99.8713 247.674 99.6396 247.227 99.4219C246.231 98.9365 245.185 98.552 244.09 98.239C243.039 97.9432 241.953 97.7345 240.849 97.5988C240.097 97.5125 239.329 97.455 238.559 97.4417C238.249 97.4244 237.951 97.4375 237.639 97.4498C236.615 97.4669 235.587 97.558 234.57 97.7237C233.657 97.8657 232.756 98.0676 231.868 98.3147",
    fill: "url(#paint62_linear_3124_5336)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M247.323 100.095C247.306 99.8716 247.273 99.6621 247.241 99.4379C247.689 99.6408 248.121 99.8725 248.551 100.134C248.767 100.264 248.968 100.379 249.182 100.525C249.483 100.719 249.768 100.928 250.024 101.12C249.967 101.873 249.778 102.604 249.458 103.298C249.424 103.37 249.39 103.442 249.357 103.515C249.307 103.601 249.274 103.673 249.24 103.745C249.19 103.847 249.157 103.904 249.109 103.975C249.109 103.975 249.107 104.005 249.091 104.019C249.058 104.076 249.01 104.148 248.977 104.205C248.976 104.22 248.961 104.234 248.945 104.248C248.912 104.306 248.864 104.377 248.831 104.434C248.83 104.449 248.814 104.463 248.799 104.477C248.751 104.534 248.718 104.606 248.67 104.663C248.67 104.663 248.653 104.691 248.638 104.705C248.59 104.762 248.542 104.834 248.509 104.891C248.269 105.204 248.046 105.473 247.794 105.741C247.716 105.811 247.669 105.867 247.622 105.909C247.591 105.937 247.574 105.966 247.544 105.979C247.497 106.021 247.45 106.063 247.418 106.105C247.387 106.133 247.356 106.161 247.325 106.189C247.278 106.231 247.246 106.274 247.2 106.301C247.169 106.329 247.122 106.371 247.09 106.399C247.044 106.44 247.012 106.468 246.966 106.51C246.934 106.538 246.888 106.58 246.856 106.608C246.81 106.65 246.778 106.678 246.732 106.72C246.686 106.747 246.654 106.789 246.608 106.817C246.562 106.844 246.53 106.886 246.484 106.913C246.437 106.955 246.391 106.982 246.344 107.024C246.298 107.051 246.266 107.094 246.22 107.121C246.173 107.163 246.127 107.19 246.08 107.232C246.034 107.259 246.003 107.287 245.956 107.329C245.909 107.371 245.849 107.397 245.802 107.439C245.756 107.466 245.725 107.494 245.679 107.521C245.617 107.562 245.555 107.603 245.509 107.63C245.463 107.657 245.432 107.685 245.386 107.712C245.325 107.753 245.248 107.794 245.187 107.835C245.156 107.848 245.125 107.876 245.095 107.889C244.987 107.957 244.895 108.011 244.788 108.065L241.006 110.226C239.857 110.889 238.996 111.701 238.501 112.608C238.468 112.665 238.45 112.709 238.418 112.766C238.417 112.781 238.4 112.81 238.385 112.824C238.368 112.852 238.351 112.896 238.335 112.925C238.333 112.954 238.317 112.968 238.301 112.997C238.299 113.026 238.268 113.054 238.266 113.084C238.265 113.113 238.249 113.127 238.233 113.156C238.231 113.186 238.215 113.214 238.198 113.243C238.197 113.273 238.18 113.302 238.165 113.315C238.163 113.345 238.161 113.375 238.146 113.389C238.144 113.418 238.128 113.447 238.126 113.476C238.125 113.491 238.124 113.506 238.123 113.521C238.105 113.594 238.086 113.667 238.067 113.74C238.066 113.755 238.065 113.77 238.064 113.784C238.062 113.829 238.06 113.858 238.058 113.903C238.057 113.917 238.056 113.932 238.055 113.947C238.053 113.991 238.051 114.021 238.049 114.065C238.049 114.065 238.047 114.095 238.046 114.11C238.044 114.154 238.041 114.198 238.04 114.228C238.024 114.509 238.026 114.746 238.071 115.001C237.804 115.001 237.537 115.001 237.27 115.001C236.618 114.994 235.983 114.944 235.348 114.894C235.353 114.82 235.341 114.76 235.33 114.685C235.332 114.655 235.333 114.641 235.334 114.611C235.337 114.567 235.339 114.522 235.342 114.478C235.344 114.448 235.345 114.419 235.346 114.404C235.348 114.36 235.351 114.315 235.353 114.271C235.355 114.241 235.357 114.212 235.358 114.182C235.361 114.138 235.362 114.108 235.365 114.064C235.367 114.035 235.368 114.005 235.37 113.975C235.372 113.931 235.374 113.901 235.376 113.857C235.378 113.828 235.38 113.798 235.381 113.768C235.384 113.724 235.386 113.68 235.389 113.635C235.39 113.606 235.391 113.591 235.393 113.562C235.396 113.502 235.415 113.429 235.433 113.371C235.437 113.297 235.471 113.225 235.49 113.152C235.491 113.137 235.492 113.107 235.508 113.093C235.51 113.049 235.528 113.006 235.545 112.962C235.547 112.932 235.547 112.918 235.564 112.889C235.566 112.845 235.598 112.802 235.6 112.772C235.602 112.743 235.618 112.714 235.634 112.685C235.637 112.641 235.669 112.598 235.685 112.57C235.687 112.54 235.703 112.511 235.719 112.497C235.736 112.454 235.754 112.41 235.77 112.381C235.772 112.352 235.787 112.338 235.804 112.309C235.821 112.266 235.853 112.223 235.87 112.179C235.871 112.165 235.887 112.136 235.903 112.122C235.936 112.064 235.97 111.992 236.017 111.936C236.655 110.859 237.718 109.88 239.097 109.082L242.88 106.92C244.657 105.892 245.988 104.632 246.719 103.22C246.768 103.133 246.803 103.046 246.851 102.975C246.853 102.945 246.869 102.917 246.886 102.888C246.918 102.83 246.937 102.772 246.955 102.714C246.956 102.684 246.988 102.641 246.99 102.612C247.008 102.554 247.025 102.51 247.043 102.452C247.045 102.422 247.062 102.379 247.079 102.35C247.081 102.306 247.114 102.248 247.131 102.205C247.134 102.16 247.15 102.132 247.167 102.088C247.17 102.044 247.203 101.986 247.205 101.942C247.208 101.897 247.224 101.869 247.241 101.825C247.244 101.781 247.262 101.723 247.279 101.679C247.282 101.635 247.283 101.605 247.3 101.562C247.305 101.488 247.324 101.4 247.343 101.327C247.346 101.282 247.348 101.238 247.351 101.179C247.354 101.135 247.356 101.105 247.358 101.061C247.361 101.016 247.364 100.957 247.366 100.913C247.368 100.883 247.37 100.839 247.372 100.809C247.375 100.765 247.378 100.706 247.38 100.662C247.382 100.632 247.384 100.602 247.386 100.558C247.389 100.499 247.392 100.455 247.395 100.395C247.397 100.366 247.398 100.336 247.4 100.307C247.403 100.248 247.407 100.189 247.394 100.143C247.396 100.114 247.397 100.099 247.398 100.069L247.323 100.095Z",
    fill: "url(#paint63_linear_3124_5336)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M241.015 97.8155C240.96 97.7383 240.904 97.6759 240.863 97.6143C241.967 97.7499 243.053 97.9586 244.104 98.2544C244.144 98.3308 244.17 98.4063 244.211 98.4679C244.25 98.5591 244.276 98.6346 244.302 98.6954C244.34 98.8014 244.366 98.8769 244.392 98.9377C244.441 99.1184 244.493 99.2547 244.515 99.4042C244.539 99.4945 244.55 99.5692 244.56 99.644C244.584 99.7491 244.58 99.823 244.592 99.8829C244.611 100.062 244.618 100.211 244.624 100.359C244.619 100.463 244.615 100.522 244.611 100.596C244.606 100.699 244.601 100.773 244.597 100.847C244.587 101.024 244.564 101.171 244.527 101.318C244.521 101.421 244.488 101.479 244.469 101.552C244.449 101.654 244.43 101.727 244.396 101.8C244.361 101.901 244.342 101.975 244.308 102.047C243.784 103.471 242.571 104.753 240.809 105.767L237.026 107.928C235.479 108.821 234.277 109.896 233.484 111.097C233.436 111.168 233.402 111.241 233.353 111.312C233.352 111.342 233.321 111.355 233.32 111.384C233.288 111.427 233.27 111.485 233.238 111.528C233.236 111.558 233.205 111.586 233.188 111.614C233.171 111.658 233.139 111.701 233.122 111.744C233.12 111.774 233.089 111.802 233.073 111.83C233.055 111.874 233.038 111.917 233.006 111.96C233.004 111.99 232.973 112.018 232.971 112.047C232.954 112.091 232.937 112.134 232.92 112.178C232.918 112.207 232.887 112.235 232.884 112.279C232.882 112.324 232.85 112.367 232.833 112.41C232.831 112.44 232.814 112.483 232.797 112.512C232.795 112.556 232.763 112.599 232.76 112.643C232.759 112.673 232.742 112.702 232.725 112.745C232.706 112.818 232.687 112.891 232.668 112.964C232.666 113.009 232.664 113.038 232.647 113.082C232.645 113.126 232.643 113.156 232.626 113.199C232.623 113.244 232.621 113.288 232.604 113.317C232.603 113.346 232.6 113.391 232.598 113.42C232.596 113.464 232.594 113.509 232.591 113.553C232.589 113.583 232.588 113.612 232.585 113.657C232.583 113.701 232.58 113.745 232.578 113.79C232.576 113.819 232.575 113.849 232.573 113.878C232.57 113.923 232.568 113.967 232.566 114.011C232.564 114.041 232.562 114.071 232.561 114.1C232.558 114.144 232.556 114.189 232.553 114.233C232.552 114.263 232.55 114.292 232.549 114.307C232.547 114.351 232.543 114.411 232.541 114.455C231.619 114.24 230.729 113.968 229.859 113.623C229.863 113.55 229.867 113.476 229.87 113.417C229.876 113.313 229.894 113.255 229.913 113.182C229.914 113.167 229.916 113.137 229.916 113.123C229.92 113.063 229.938 113.005 229.956 112.947C229.957 112.917 229.958 112.902 229.96 112.873C229.963 112.814 229.981 112.755 229.999 112.697C230.001 112.668 230.002 112.653 230.004 112.623C230.007 112.564 230.04 112.507 230.057 112.463C230.059 112.434 230.06 112.404 230.076 112.39C230.079 112.331 230.111 112.288 230.129 112.23C230.131 112.2 230.147 112.172 230.164 112.143C230.182 112.085 230.199 112.041 230.217 111.983C230.219 111.953 230.235 111.924 230.252 111.896C230.27 111.837 230.287 111.794 230.32 111.736C230.321 111.707 230.338 111.678 230.354 111.649C230.372 111.591 230.404 111.548 230.422 111.49C230.424 111.46 230.455 111.433 230.457 111.403C230.475 111.345 230.507 111.302 230.525 111.244C230.527 111.214 230.558 111.186 230.574 111.157C230.607 111.1 230.625 111.056 230.657 110.999C230.659 110.969 230.69 110.941 230.707 110.913C230.739 110.87 230.757 110.812 230.789 110.769C230.79 110.739 230.822 110.712 230.838 110.683C230.87 110.64 230.903 110.583 230.935 110.54C230.937 110.51 230.967 110.497 230.984 110.468C231.097 110.297 231.225 110.126 231.353 109.955C231.37 109.927 231.386 109.898 231.417 109.87C231.449 109.827 231.481 109.784 231.513 109.742C231.544 109.714 231.562 109.67 231.593 109.642C231.625 109.6 231.656 109.572 231.688 109.529C231.72 109.486 231.751 109.458 231.784 109.416C231.816 109.373 231.847 109.345 231.879 109.302C231.911 109.26 231.942 109.232 231.974 109.189C232.005 109.161 232.037 109.119 232.069 109.091C232.101 109.048 232.132 109.02 232.179 108.978C232.21 108.95 232.242 108.907 232.273 108.88C232.305 108.837 232.351 108.81 232.383 108.767C232.414 108.739 232.446 108.696 232.492 108.669C232.524 108.627 232.57 108.6 232.602 108.557C232.634 108.529 232.68 108.487 232.712 108.459C232.758 108.417 232.79 108.389 232.836 108.347C232.868 108.32 232.914 108.278 232.946 108.25C232.992 108.208 233.024 108.18 233.071 108.138C233.102 108.11 233.148 108.083 233.18 108.04C233.227 107.998 233.273 107.971 233.319 107.93C233.351 107.902 233.397 107.875 233.428 107.847C233.475 107.805 233.521 107.778 233.567 107.736C233.599 107.708 233.645 107.681 233.676 107.653C233.723 107.611 233.783 107.585 233.83 107.543C233.861 107.515 233.907 107.488 233.939 107.46C233.985 107.418 234.046 107.392 234.093 107.35C234.139 107.323 234.17 107.295 234.216 107.268C234.278 107.227 234.324 107.2 234.385 107.159C234.417 107.131 234.462 107.118 234.493 107.09C234.555 107.049 234.631 107.009 234.693 106.968C234.723 106.955 234.754 106.927 234.785 106.914C234.877 106.86 234.984 106.792 235.091 106.738L238.844 104.575C240.483 103.628 241.516 102.395 241.799 101.032C241.803 100.958 241.822 100.9 241.84 100.827C241.845 100.738 241.849 100.664 241.853 100.605C241.859 100.502 241.862 100.443 241.866 100.369C241.872 100.265 241.875 100.206 241.879 100.132C241.883 100.058 241.872 99.9984 241.861 99.9237C241.851 99.8341 241.841 99.7594 241.829 99.6995C241.82 99.5952 241.794 99.5344 241.782 99.4744C241.758 99.3841 241.747 99.3094 241.721 99.2486C241.695 99.173 241.684 99.1131 241.658 99.0375C241.634 98.9472 241.607 98.8864 241.582 98.8109C241.543 98.7197 241.517 98.6441 241.491 98.5834C241.451 98.4922 241.425 98.4314 241.384 98.3698C241.344 98.2935 241.303 98.2319 241.262 98.1703C241.208 98.0783 241.167 98.0167 241.126 97.9551C241.071 97.8631 241.015 97.8007 240.974 97.7391L241.015 97.8155Z",
    fill: "url(#paint64_linear_3124_5336)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M257.986 83.028L263.883 79.6494L282.718 90.7661C283.105 90.9953 283.478 91.2237 283.821 91.4504C290.016 95.5022 290.278 99.5796 282.575 103.985C276.479 107.471 270.737 107.27 265.004 105.571L270.671 102.328C273.049 103.024 275.169 102.505 277.712 101.045C281.372 98.9503 282.104 97.5231 278.413 95.1082C278.141 94.93 277.855 94.7509 277.538 94.5702L275.772 93.5377C276.509 95.2098 276.11 96.789 272.603 98.7882C267.395 101.775 258.118 101.956 252.031 98.3694C251.816 98.2388 251.601 98.1081 251.385 97.9775C245.777 94.3142 245.966 89.313 251.327 86.2455C254.681 84.3268 258.14 84.2525 260.784 84.6962L257.97 83.042L257.986 83.028ZM266.556 88.087C262.884 86.9335 260.611 86.7476 257.073 88.76C254.347 90.3282 254.137 92.2293 257.528 94.4495C257.728 94.5793 257.943 94.7099 258.173 94.8413C262.695 97.51 265.82 97.3133 268.776 95.6244C272.574 93.4487 272.175 92.1067 269.945 90.0698L266.556 88.087Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M190.047 121.327C196.664 117.529 206.078 117.564 212.697 121.462C212.94 121.609 213.17 121.755 213.399 121.901C219.336 125.79 218.958 130.974 212.587 134.622C205.924 138.433 196.598 138.418 189.952 134.489C189.708 134.342 189.479 134.196 189.25 134.05C183.341 130.192 183.645 125.004 190.062 121.328L190.047 121.327ZM206.556 124.96C201.99 122.274 198.486 122.361 195.101 124.307C191.885 126.145 191.527 128.038 195.29 130.501C195.533 130.663 195.791 130.825 196.063 130.989C200.686 133.708 204.117 133.602 207.533 131.642C210.719 129.818 211.135 127.943 207.358 125.464C207.115 125.303 206.842 125.139 206.555 124.975",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M144.235 139.581L150.438 136.026L161.319 142.46L172.514 136.069L161.618 129.635L167.821 126.081L196.663 143.093L190.474 146.663L178.056 139.329L166.861 145.719L179.279 153.053L173.09 156.608L144.235 139.581Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M337.605 54.8705L343.196 51.6676C345.1 52.3519 346.591 52.4794 349.592 50.7634C352.104 49.3315 352.867 48.4102 351.693 47.648C351.65 47.6307 351.622 47.5995 351.578 47.5823C350.042 46.6812 349.189 46.8264 345.237 48.2968C340.754 49.9748 334.334 52.1083 329.424 49.2105C329.295 49.1291 329.18 49.0634 329.066 48.9829C325.003 46.325 327.201 42.7997 331.996 40.0418C337.096 37.123 342.698 36.6342 347.983 38.6633L342.407 41.8671C340.493 41.3601 339.335 41.3846 336.946 42.7492C334.495 44.1548 334.123 44.9793 335.21 45.6922C335.253 45.7243 335.296 45.7415 335.339 45.7736C336.502 46.4611 337.789 46.251 341.802 44.7396C346.527 42.9713 352.401 41.0594 357.196 43.8916C357.34 43.9737 357.469 44.055 357.598 44.1363C362.147 47.1179 359.199 50.7942 354.512 53.4839C348.86 56.7279 343.456 57.1091 337.59 54.8845L337.605 54.8705Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M306.598 55.1902L310.641 52.8798L307.684 51.1286C307.511 51.03 307.354 50.9323 307.196 50.8345C302.947 48.0624 303.146 44.2183 307.297 41.8397C308.706 41.0285 310.287 40.3306 312.01 39.7445L317.005 42.7064C315.633 43.1193 314.388 43.6431 313.299 44.2795C311.6 45.2376 311.348 46.306 313.264 47.5693C313.365 47.6342 313.479 47.7147 313.609 47.7812L316.538 49.5012L322.25 46.231L327.304 49.211L321.591 52.4812L338.014 62.1737L332.118 65.5523L315.694 55.8598L311.666 58.1711L306.612 55.191L306.598 55.1902Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M293.491 62.0975C299.663 58.5711 306.12 58.4561 311.489 61.6168L318.194 65.5636C319.602 66.3834 320.586 66.2751 321.596 65.7086L322.087 65.4245L327.14 68.4045L326.252 68.9037C322.898 70.8225 320.77 70.9709 318.217 70.4729C319.151 72.0818 317.61 74.4574 314.317 76.3499C310.135 78.7416 303.85 79.7707 299.041 76.9377C298.911 76.8711 298.797 76.7906 298.682 76.7249C294.447 73.9536 297.059 70.1993 301.316 67.7674C302.866 66.8305 304.801 66.1672 306.971 65.7988L305.363 64.8492C302.88 63.3765 301.109 63.2334 298.26 64.8689C296.284 66.0044 295.573 66.7804 296.648 67.9819L290.905 71.2653C287.579 67.6252 289.126 64.5976 293.491 62.0975ZM310.977 68.157C309.175 68.2939 307.795 68.5877 305.391 69.9515C303.094 71.2619 302.971 72.1299 304.53 73.1509C304.631 73.2158 304.731 73.2807 304.846 73.3464C306.612 74.3789 308.123 74.4037 310.344 73.1335C312.611 71.8215 313.521 70.938 313.058 69.3998L310.977 68.157Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M268.293 77.1226L274.175 73.7432L277.305 75.593C276.077 73.6712 276.86 71.6092 279.586 70.041C280.459 69.541 281.505 69.1247 282.36 68.9647L288.116 72.3694C287.217 72.5417 286.155 72.9719 285.021 73.6353C281.835 75.4597 281.167 77.6022 284.987 80.0984C285.187 80.2281 285.402 80.3587 285.632 80.5049L295.637 86.4149L289.741 89.7935L268.279 77.1218L268.293 77.1226Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M236.917 103.473C238.342 102.648 239.16 101.537 239.197 100.338C239.225 99.3165 238.688 98.2932 237.654 97.4349C237.966 97.4226 238.262 97.4243 238.574 97.4268C239.344 97.44 240.096 97.5115 240.863 97.5839C241.736 98.6853 242.084 99.8909 241.84 101.078C241.556 102.442 240.524 103.674 238.885 104.621L235.132 106.784C231.992 108.581 230.137 110.999 229.859 113.593C228.989 113.248 228.136 112.845 227.332 112.385C227.98 109.796 230.009 107.433 233.165 105.622L236.918 103.458L236.917 103.473Z",
    fill: "#161616"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.736 200.946L307.674 196.556C315.422 193.128 322.882 187.43 329.159 180.149C327.892 184.141 325.993 187.995 323.557 191.573C318.629 198.772 311.527 204.869 303.09 208.599C296.855 211.351 291.24 212.246 286.602 211.462C287.868 209.232 289.464 207.167 291.295 205.392C293.277 203.465 295.493 201.951 297.75 200.946H297.736Z",
    fill: "url(#paint65_linear_3124_5336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.717 149.856C328.236 152.691 331.663 158.637 331.98 167.226C332.297 175.814 329.448 184.595 324.314 192.11C319.18 199.625 311.803 205.929 303.118 209.769C294.433 213.609 286.767 213.967 281.261 211.159C275.742 208.337 272.356 202.378 272.026 193.748C271.696 185.118 274.531 176.447 279.665 168.919C284.785 161.39 292.176 155.072 300.902 151.205C309.628 147.337 317.198 147.062 322.717 149.884V149.856ZM330.851 171.107C330.92 169.978 330.934 168.836 330.893 167.694C330.576 159.408 327.3 153.737 322.015 151.026C316.716 148.328 309.394 148.604 300.943 152.32C292.451 156.077 285.349 162.188 280.436 169.4C276.706 174.892 274.228 181.044 273.402 187.32C273.141 189.289 273.045 191.257 273.127 193.225C273.127 193.528 273.155 193.817 273.168 194.12C273.306 196.198 273.636 198.111 274.132 199.845C274.627 201.552 275.288 203.08 276.114 204.429C276.912 205.736 277.862 206.878 278.935 207.856C279.857 208.682 280.876 209.37 281.977 209.934C282.142 210.017 282.307 210.099 282.473 210.168C283.739 210.76 285.115 211.186 286.602 211.434C291.24 212.219 296.855 211.338 303.09 208.571C311.541 204.841 318.643 198.744 323.557 191.546C325.993 187.967 327.892 184.114 329.159 180.122C330.094 177.163 330.673 174.135 330.851 171.093",
    fill: "url(#paint66_linear_3124_5336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.691 166.977L332.476 166.633L332.503 167.472L331.719 167.816L331.691 166.977Z",
    fill: "url(#paint67_linear_3124_5336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.694 176.873C324.576 173.02 327.92 168.491 330.466 163.633C330.7 164.913 330.838 166.262 330.893 167.693C330.934 168.835 330.921 169.964 330.852 171.106C324.672 180.232 316.317 187.485 307.467 191.408L297.53 195.798C294.502 197.133 291.529 199.198 288.859 201.799C286.34 204.235 284.152 207.112 282.459 210.195C282.294 210.112 282.129 210.044 281.964 209.961C280.863 209.397 279.844 208.695 278.922 207.883C281.069 204.166 283.767 200.712 286.85 197.794C290.098 194.711 293.676 192.261 297.324 190.651L307.261 186.26C312.009 184.168 316.593 180.961 320.681 176.887L320.694 176.873Z",
    fill: "url(#paint68_linear_3124_5336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.35 190.637C293.703 192.247 290.124 194.697 286.876 197.78C283.793 200.712 281.096 204.153 278.948 207.869C277.875 206.905 276.925 205.763 276.127 204.442C278.715 200.326 281.839 196.555 285.349 193.348C289.037 189.976 293.07 187.292 297.158 185.489L307.095 181.099C311.747 179.034 316.234 175.676 320.074 171.382C323.721 167.308 326.625 162.559 328.511 157.618C329.419 159.366 330.08 161.376 330.479 163.647C327.919 168.505 324.588 173.033 320.707 176.887C316.619 180.961 312.036 184.168 307.356 186.233L297.364 190.651L297.35 190.637Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.684 166.482C321.849 162.476 324.134 157.852 325.221 153.269C326.515 154.466 327.616 155.911 328.497 157.618C326.611 162.559 323.707 167.307 320.06 171.381C316.22 175.676 311.719 179.034 307.081 181.098L297.144 185.489C293.042 187.306 289.023 189.976 285.334 193.348C281.825 196.555 278.687 200.326 276.113 204.441C275.287 203.093 274.626 201.565 274.131 199.858C280.256 191.091 288.39 184.126 296.951 180.341L306.888 175.951C311.21 174.024 315.353 170.707 318.684 166.482Z",
    fill: "url(#paint69_linear_3124_5336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.889 175.953L296.951 180.343C288.39 184.128 280.256 191.092 274.131 199.86C273.636 198.126 273.306 196.226 273.168 194.134C279.83 185.67 288.115 179.008 296.759 175.182L306.696 170.791C310.467 169.112 314.046 166.029 316.688 162.134C319.18 158.459 320.707 154.358 320.955 150.531C321.313 150.683 321.671 150.848 322.015 151.013C323.185 151.619 324.258 152.362 325.222 153.243C324.134 157.826 321.85 162.437 318.684 166.456C315.34 170.681 311.21 174.012 306.889 175.925V175.953Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.908 193.527L272.674 187.444L273.72 186.976L273.954 193.073L272.908 193.527Z",
    fill: "url(#paint70_linear_3124_5336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.028 150.957L315.973 149.333C317.776 149.512 319.441 149.911 320.955 150.544C320.955 150.641 320.942 150.751 320.928 150.847C320.928 150.998 320.9 151.095 320.9 151.191C320.887 151.37 320.873 151.453 320.859 151.549C320.832 151.742 320.818 151.824 320.818 151.907C320.79 152.113 320.777 152.196 320.763 152.278C320.735 152.485 320.708 152.567 320.694 152.65C320.653 152.856 320.639 152.939 320.625 153.022C320.584 153.228 320.57 153.311 320.543 153.393C320.487 153.613 320.474 153.682 320.46 153.765C320.46 153.806 320.432 153.861 320.432 153.903C320.419 153.985 320.391 154.054 320.377 154.136C320.377 154.178 320.35 154.233 320.336 154.274C320.309 154.357 320.295 154.439 320.267 154.508C320.212 154.728 320.185 154.811 320.157 154.88C320.088 155.1 320.075 155.183 320.047 155.265C319.978 155.472 319.951 155.554 319.923 155.65C319.841 155.884 319.772 156.091 319.689 156.297C319.634 156.463 319.607 156.531 319.579 156.614C319.565 156.669 319.538 156.724 319.524 156.765C319.497 156.834 319.469 156.903 319.441 156.972C319.414 157.027 319.4 157.096 319.373 157.151C319.345 157.22 319.318 157.275 319.29 157.343C319.263 157.398 319.235 157.467 319.207 157.522C319.18 157.591 319.152 157.646 319.125 157.715C319.097 157.784 319.07 157.839 319.042 157.908C319.015 157.963 318.987 158.032 318.96 158.087C318.932 158.155 318.905 158.211 318.877 158.279C318.85 158.334 318.822 158.403 318.795 158.458C318.767 158.527 318.74 158.582 318.698 158.651C318.671 158.706 318.643 158.775 318.616 158.83C318.588 158.899 318.547 158.967 318.519 159.023C318.492 159.078 318.464 159.146 318.423 159.201C318.395 159.27 318.354 159.339 318.327 159.394C318.299 159.449 318.272 159.504 318.23 159.573C318.189 159.642 318.161 159.711 318.12 159.78C318.093 159.835 318.065 159.89 318.024 159.945C317.983 160.014 317.955 160.082 317.914 160.151C317.886 160.206 317.845 160.261 317.817 160.316C317.776 160.385 317.735 160.454 317.694 160.523C317.666 160.578 317.625 160.633 317.597 160.688C317.556 160.757 317.515 160.826 317.473 160.894C317.446 160.949 317.404 160.991 317.377 161.046C317.336 161.115 317.281 161.197 317.239 161.266C317.212 161.307 317.184 161.362 317.157 161.404C317.102 161.486 317.06 161.555 317.005 161.638C316.84 161.885 316.771 161.995 316.689 162.119C314.046 166.001 310.468 169.097 306.696 170.777L296.759 175.167C296.621 175.222 296.484 175.291 296.346 175.346C296.126 175.442 296.03 175.484 295.933 175.539C295.878 175.566 295.823 175.594 295.768 175.608C295.686 175.649 295.603 175.69 295.52 175.718C295.452 175.745 295.383 175.787 295.328 175.814C295.259 175.842 295.19 175.883 295.121 175.91C295.052 175.938 294.984 175.979 294.915 176.007C294.846 176.034 294.777 176.076 294.708 176.103C294.64 176.131 294.571 176.172 294.502 176.199C294.433 176.227 294.364 176.268 294.295 176.296C294.227 176.323 294.158 176.365 294.089 176.406C294.02 176.447 293.951 176.475 293.883 176.516C293.814 176.557 293.745 176.585 293.676 176.626C293.607 176.667 293.538 176.695 293.47 176.736C293.401 176.778 293.332 176.805 293.263 176.846C293.194 176.874 293.139 176.915 293.07 176.943C293.002 176.984 292.919 177.025 292.85 177.067C292.795 177.094 292.726 177.135 292.671 177.163C292.603 177.204 292.534 177.246 292.465 177.287C292.396 177.328 292.341 177.356 292.272 177.397C292.203 177.438 292.135 177.479 292.052 177.521C291.997 177.562 291.928 177.59 291.873 177.631C291.804 177.672 291.722 177.713 291.653 177.769C291.598 177.796 291.543 177.837 291.488 177.865C291.405 177.906 291.336 177.961 291.254 178.003C291.199 178.03 291.144 178.071 291.089 178.099C291.006 178.14 290.923 178.195 290.855 178.236C290.8 178.264 290.744 178.305 290.703 178.333C290.621 178.388 290.538 178.429 290.469 178.484C290.414 178.512 290.359 178.553 290.304 178.581C290.221 178.636 290.139 178.677 290.07 178.732C290.015 178.759 289.96 178.801 289.919 178.828C289.836 178.883 289.753 178.925 289.671 178.98C289.616 179.007 289.575 179.049 289.52 179.076C289.437 179.131 289.354 179.186 289.272 179.241C289.217 179.269 289.175 179.31 289.12 179.338C289.038 179.393 288.955 179.448 288.873 179.503C288.831 179.53 288.776 179.572 288.735 179.599C288.652 179.654 288.57 179.709 288.487 179.764C288.446 179.792 288.405 179.819 288.35 179.847C288.267 179.902 288.171 179.971 288.088 180.026C288.047 180.053 288.006 180.081 287.964 180.108C287.882 180.163 287.785 180.232 287.703 180.287C287.661 180.315 287.62 180.342 287.579 180.37C287.482 180.439 287.4 180.494 287.304 180.563C287.097 180.7 287.015 180.769 286.918 180.838C286.725 180.975 286.629 181.044 286.533 181.113C286.34 181.251 286.244 181.32 286.147 181.402C285.955 181.54 285.858 181.622 285.762 181.691C285.583 181.829 285.487 181.898 285.377 181.98C285.211 182.118 285.101 182.187 284.991 182.269C284.826 182.393 284.716 182.489 284.606 182.572C284.468 182.682 284.344 182.778 284.234 182.875C281.234 185.283 278.399 188.009 275.756 190.995C275.646 191.119 275.536 191.243 275.426 191.367C275.315 191.505 275.205 191.628 275.095 191.752C274.985 191.89 274.875 192.014 274.765 192.138C274.655 192.275 274.545 192.399 274.448 192.523C274.338 192.661 274.228 192.785 274.132 192.908C274.008 193.046 273.912 193.17 273.815 193.294C273.691 193.445 273.595 193.569 273.499 193.693C273.389 193.831 273.278 193.968 273.182 194.092C273.155 193.803 273.141 193.514 273.127 193.211C273.058 191.243 273.155 189.261 273.402 187.307C274.049 186.591 274.696 185.889 275.357 185.201C275.467 185.077 275.577 184.967 275.687 184.857C275.811 184.733 275.907 184.623 276.017 184.526C276.141 184.403 276.251 184.292 276.348 184.196C276.472 184.072 276.582 183.962 276.678 183.866C276.816 183.728 276.912 183.632 277.022 183.535C277.16 183.398 277.256 183.301 277.366 183.205C277.504 183.081 277.6 182.985 277.71 182.875C277.848 182.751 277.958 182.641 278.054 182.544C278.192 182.421 278.288 182.324 278.399 182.214C278.522 182.09 278.633 181.994 278.743 181.898C278.866 181.787 278.977 181.677 279.087 181.581C279.211 181.471 279.321 181.361 279.431 181.264C279.555 181.154 279.665 181.058 279.789 180.948C281.537 179.393 283.34 177.947 285.17 176.626C285.28 176.544 285.39 176.475 285.501 176.392C285.652 176.282 285.762 176.213 285.858 176.131C286.024 176.021 286.12 175.952 286.216 175.883C286.381 175.759 286.478 175.704 286.574 175.635C286.767 175.498 286.849 175.442 286.946 175.387C287.138 175.25 287.235 175.195 287.317 175.14C287.51 175.002 287.606 174.947 287.689 174.892C287.73 174.864 287.772 174.837 287.813 174.809C287.895 174.754 287.978 174.699 288.061 174.644C288.102 174.617 288.143 174.589 288.184 174.562C288.267 174.507 288.35 174.452 288.432 174.396C288.473 174.369 288.529 174.341 288.57 174.314C288.652 174.259 288.735 174.218 288.804 174.162C288.859 174.135 288.9 174.094 288.955 174.066C289.038 174.025 289.107 173.97 289.189 173.928C289.244 173.901 289.299 173.86 289.341 173.832C289.409 173.791 289.492 173.736 289.561 173.695C289.616 173.667 289.671 173.626 289.712 173.598C289.781 173.557 289.864 173.502 289.932 173.461C289.987 173.433 290.042 173.392 290.098 173.364C290.166 173.323 290.249 173.282 290.318 173.227C290.373 173.199 290.428 173.158 290.483 173.13C290.552 173.089 290.634 173.048 290.703 173.006C290.758 172.979 290.813 172.938 290.868 172.91C290.937 172.869 291.02 172.827 291.089 172.786C291.144 172.759 291.199 172.717 291.254 172.69C291.323 172.648 291.391 172.607 291.46 172.566C291.515 172.525 291.584 172.497 291.639 172.47C291.708 172.428 291.777 172.401 291.846 172.359C291.901 172.332 291.969 172.291 292.024 172.263C292.093 172.222 292.162 172.181 292.231 172.153C292.286 172.125 292.355 172.084 292.41 172.057C292.479 172.015 292.547 171.974 292.616 171.947C292.671 171.919 292.74 171.878 292.795 171.85C292.864 171.809 292.933 171.781 293.002 171.74C293.071 171.713 293.126 171.671 293.194 171.644C293.263 171.602 293.332 171.575 293.401 171.534C293.47 171.506 293.525 171.465 293.594 171.437C293.662 171.41 293.731 171.368 293.786 171.341C293.855 171.313 293.91 171.272 293.979 171.245C294.048 171.217 294.116 171.176 294.172 171.148C294.24 171.121 294.309 171.079 294.364 171.052C294.433 171.024 294.488 170.983 294.557 170.956C294.626 170.914 294.695 170.887 294.777 170.845C294.832 170.818 294.901 170.79 294.956 170.763C295.025 170.722 295.107 170.694 295.176 170.653C295.231 170.625 295.3 170.598 295.355 170.57C295.424 170.543 295.493 170.501 295.562 170.474C295.617 170.446 295.686 170.419 295.741 170.391C295.823 170.35 295.92 170.309 296.002 170.267C296.043 170.254 296.085 170.226 296.126 170.212C296.264 170.157 296.388 170.088 296.525 170.033L306.449 165.643C309.091 164.473 311.569 162.271 313.358 159.518C315.147 156.765 316.097 153.682 316.001 150.943L316.028 150.957Z",
    fill: "url(#paint71_linear_3124_5336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.49 165.657L296.566 170.047C288.281 173.709 280.257 179.696 273.402 187.348C273.76 184.609 274.435 181.884 275.398 179.241C281.881 173.048 289.038 168.148 296.374 164.9L306.311 160.509C307.632 159.931 308.871 158.816 309.752 157.454C310.647 156.077 311.128 154.536 311.073 153.16L310.936 149.443C312.711 149.223 314.39 149.196 315.973 149.347L316.028 150.971C316.138 153.696 315.175 156.779 313.386 159.546C311.596 162.299 309.119 164.501 306.476 165.671L306.49 165.657Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.436 169.414C285.35 162.189 292.452 156.091 300.944 152.334C304.495 150.765 307.839 149.815 310.922 149.43L311.06 153.146C311.115 154.522 310.633 156.05 309.739 157.44C308.844 158.803 307.605 159.918 306.298 160.496L296.36 164.886C296.126 164.996 295.892 165.093 295.659 165.203C295.576 165.244 295.507 165.272 295.425 165.313C295.273 165.382 295.122 165.45 294.957 165.533C294.86 165.574 294.764 165.616 294.681 165.671C294.544 165.74 294.406 165.808 294.268 165.877C294.172 165.932 294.062 165.973 293.966 166.029C293.828 166.097 293.704 166.166 293.566 166.221C293.47 166.276 293.36 166.331 293.264 166.373C293.14 166.441 293.002 166.51 292.878 166.565C292.768 166.62 292.658 166.675 292.562 166.73C292.438 166.799 292.314 166.854 292.19 166.923C292.08 166.978 291.97 167.047 291.86 167.102C291.736 167.171 291.612 167.226 291.502 167.295C291.392 167.35 291.282 167.419 291.172 167.474C291.048 167.543 290.938 167.611 290.814 167.666C290.704 167.735 290.594 167.79 290.47 167.859C290.36 167.928 290.236 167.997 290.126 168.066C290.015 168.134 289.892 168.203 289.781 168.272C289.671 168.341 289.561 168.41 289.437 168.478C289.327 168.547 289.203 168.616 289.093 168.685C288.983 168.754 288.873 168.823 288.763 168.891C288.639 168.96 288.529 169.029 288.405 169.112C288.295 169.18 288.185 169.249 288.075 169.318C287.951 169.387 287.841 169.469 287.717 169.538C287.607 169.607 287.497 169.676 287.387 169.745C287.263 169.827 287.153 169.896 287.029 169.979C286.919 170.047 286.822 170.116 286.712 170.185C286.588 170.268 286.478 170.337 286.354 170.419C286.244 170.488 286.148 170.557 286.038 170.626C285.914 170.708 285.79 170.791 285.68 170.873C285.584 170.942 285.473 171.011 285.377 171.08C285.253 171.162 285.129 171.245 285.006 171.328C284.909 171.396 284.813 171.465 284.703 171.534C284.579 171.617 284.455 171.713 284.331 171.795C284.235 171.864 284.138 171.933 284.042 172.002C283.918 172.098 283.794 172.181 283.657 172.277C283.56 172.346 283.464 172.415 283.381 172.484C283.258 172.58 283.12 172.676 282.996 172.773C282.913 172.842 282.817 172.91 282.735 172.965C282.597 173.062 282.473 173.172 282.335 173.268C282.253 173.323 282.184 173.392 282.101 173.447C281.964 173.557 281.826 173.667 281.675 173.777C281.606 173.832 281.537 173.888 281.468 173.943C281.317 174.066 281.165 174.177 281.028 174.3C280.973 174.342 280.918 174.383 280.863 174.438C280.698 174.562 280.546 174.7 280.381 174.823C280.353 174.851 280.326 174.879 280.285 174.892C279.28 175.718 278.275 176.571 277.298 177.452C277.05 177.673 276.885 177.824 276.72 177.975C276.679 178.017 276.637 178.044 276.596 178.085C276.445 178.223 276.279 178.374 276.128 178.512C276.073 178.567 276.018 178.608 275.963 178.663C275.811 178.801 275.674 178.939 275.522 179.076C275.481 179.118 275.426 179.159 275.385 179.214C276.623 175.801 278.316 172.497 280.422 169.401L280.436 169.414Z",
    fill: "url(#paint72_linear_3124_5336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.481 191.408C316.331 187.499 324.685 180.232 330.865 171.106C330.686 174.162 330.095 177.19 329.172 180.135C322.896 187.416 315.423 193.114 307.688 196.542L297.75 200.932C295.493 201.937 293.277 203.451 291.295 205.378C289.465 207.153 287.882 209.218 286.602 211.447C285.115 211.2 283.739 210.773 282.473 210.181C284.179 207.084 286.368 204.222 288.873 201.785C291.543 199.184 294.516 197.133 297.544 195.785L307.481 191.394V191.408Z",
    fill: "#151515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3124_5336",
    x1: 375.48,
    y1: 231.12,
    x2: 294.706,
    y2: 192.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3124_5336",
    x1: 171.153,
    y1: 346.281,
    x2: 245.852,
    y2: 315.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3124_5336",
    x1: 167.94,
    y1: 343.3,
    x2: 192.391,
    y2: 338.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3124_5336",
    x1: 370.064,
    y1: 235.459,
    x2: 347.75,
    y2: 225.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3124_5336",
    x1: 338.527,
    y1: 271.078,
    x2: 369.869,
    y2: 263.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3124_5336",
    x1: 348.129,
    y1: 253.806,
    x2: 355.648,
    y2: 251.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3124_5336",
    x1: 354.971,
    y1: 238.919,
    x2: 357.329,
    y2: 238.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3124_5336",
    x1: 354.339,
    y1: 254.549,
    x2: 357.174,
    y2: 253.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3124_5336",
    x1: 348.535,
    y1: 238.962,
    x2: 351.932,
    y2: 237.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3124_5336",
    x1: 356.603,
    y1: 245.059,
    x2: 358.4,
    y2: 244.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3124_5336",
    x1: 343.363,
    y1: 259.246,
    x2: 346.208,
    y2: 258.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3124_5336",
    x1: 348.498,
    y1: 259.297,
    x2: 352.05,
    y2: 257.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3124_5336",
    x1: 342.033,
    y1: 254.255,
    x2: 343.806,
    y2: 254.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3124_5336",
    x1: 343.443,
    y1: 245.708,
    x2: 346.358,
    y2: 245.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3124_5336",
    x1: 360.852,
    y1: 260.142,
    x2: 305.417,
    y2: 234.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3124_5336",
    x1: 322.062,
    y1: 262.459,
    x2: 299.748,
    y2: 252.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3124_5336",
    x1: 290.976,
    y1: 298.381,
    x2: 322.318,
    y2: 290.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3124_5336",
    x1: 300.6,
    y1: 281.109,
    x2: 308.119,
    y2: 279.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3124_5336",
    x1: 307.375,
    y1: 266.487,
    x2: 309.733,
    y2: 265.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3124_5336",
    x1: 306.765,
    y1: 282.116,
    x2: 309.6,
    y2: 281.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3124_5336",
    x1: 300.961,
    y1: 266.53,
    x2: 304.357,
    y2: 264.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3124_5336",
    x1: 309.007,
    y1: 272.626,
    x2: 310.805,
    y2: 272.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3124_5336",
    x1: 295.767,
    y1: 286.813,
    x2: 298.612,
    y2: 285.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3124_5336",
    x1: 300.923,
    y1: 286.864,
    x2: 304.476,
    y2: 285.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3124_5336",
    x1: 294.459,
    y1: 281.822,
    x2: 296.232,
    y2: 281.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3124_5336",
    x1: 295.847,
    y1: 273.275,
    x2: 298.763,
    y2: 272.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3124_5336",
    x1: 310.848,
    y1: 289.142,
    x2: 255.413,
    y2: 263.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3124_5336",
    x1: 199.957,
    y1: 337.347,
    x2: 467.824,
    y2: 243.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3124_5336",
    x1: 108.41,
    y1: 211.045,
    x2: 404.534,
    y2: 15.2304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3124_5336",
    x1: 92.8079,
    y1: 328.86,
    x2: 212.414,
    y2: 303.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3124_5336",
    x1: 26.4466,
    y1: 276.852,
    x2: 29.8199,
    y2: 276.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3124_5336",
    x1: 12.5355,
    y1: 235.316,
    x2: 28.0166,
    y2: 225.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3124_5336",
    x1: 32.4078,
    y1: 276.591,
    x2: 171.199,
    y2: 185.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3124_5336",
    x1: 161.867,
    y1: 391.817,
    x2: 149.681,
    y2: 330.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3124_5336",
    x1: 141.232,
    y1: 383.958,
    x2: 172.574,
    y2: 375.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3124_5336",
    x1: 150.834,
    y1: 366.708,
    x2: 158.353,
    y2: 364.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3124_5336",
    x1: 157.631,
    y1: 352.065,
    x2: 159.989,
    y2: 351.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3124_5336",
    x1: 156.999,
    y1: 367.694,
    x2: 159.834,
    y2: 367.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3124_5336",
    x1: 151.195,
    y1: 352.108,
    x2: 154.592,
    y2: 350.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3124_5336",
    x1: 159.263,
    y1: 358.204,
    x2: 161.061,
    y2: 357.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3124_5336",
    x1: 146.023,
    y1: 372.391,
    x2: 148.868,
    y2: 371.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3124_5336",
    x1: 151.158,
    y1: 372.464,
    x2: 154.71,
    y2: 370.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3124_5336",
    x1: 144.693,
    y1: 367.422,
    x2: 146.466,
    y2: 367.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3124_5336",
    x1: 146.082,
    y1: 358.875,
    x2: 148.997,
    y2: 358.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3124_5336",
    x1: 0.572802,
    y1: 324.28,
    x2: 9.50442,
    y2: 319.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3124_5336",
    x1: 14.9972,
    y1: 342.84,
    x2: 131.076,
    y2: 303.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3124_5336",
    x1: 92.3907,
    y1: 400.049,
    x2: 130.642,
    y2: 388.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3124_5336",
    x1: 0.783835,
    y1: 347.234,
    x2: 15.4226,
    y2: 344.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_3124_5336",
    x1: 9.78114,
    y1: 404.106,
    x2: 109.027,
    y2: 357.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3124_5336",
    x1: 47.7227,
    y1: 226.475,
    x2: 55.6295,
    y2: 223.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_3124_5336",
    x1: 71.7578,
    y1: 239.497,
    x2: 79.6647,
    y2: 236.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_3124_5336",
    x1: 95.793,
    y1: 252.519,
    x2: 103.7,
    y2: 249.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_3124_5336",
    x1: 23.664,
    y1: 362.691,
    x2: 90.3362,
    y2: 333.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_3124_5336",
    x1: 133.267,
    y1: 330.657,
    x2: 136.64,
    y2: 330.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_3124_5336",
    x1: 119.379,
    y1: 289.094,
    x2: 134.84,
    y2: 278.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_3124_5336",
    x1: 72.225,
    y1: 388.855,
    x2: 92.7474,
    y2: 380.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_3124_5336",
    x1: 82.1158,
    y1: 392.088,
    x2: 90.8598,
    y2: 388.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_3124_5336",
    x1: 3.24845,
    y1: 349.132,
    x2: 24.9923,
    y2: 341.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_3124_5336",
    x1: 3.04209,
    y1: 346.66,
    x2: 11.7619,
    y2: 343.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_3124_5336",
    x1: 252.456,
    y1: 102.173,
    x2: 238.923,
    y2: 106.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_3124_5336",
    x1: 233.182,
    y1: 97.2322,
    x2: 220.997,
    y2: 101.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_3124_5336",
    x1: 238.554,
    y1: 95.8337,
    x2: 222.74,
    y2: 100.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_3124_5336",
    x1: 252.898,
    y1: 95.2896,
    x2: 222.034,
    y2: 112.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_3124_5336",
    x1: 249.286,
    y1: 97.8171,
    x2: 232.989,
    y2: 102.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_3124_5336",
    x1: 243.944,
    y1: 95.9254,
    x2: 227.371,
    y2: 100.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_3124_5336",
    x1: 289.415,
    y1: 215.13,
    x2: 332.51,
    y2: 193.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_3124_5336",
    x1: 275.968,
    y1: 219.988,
    x2: 344.159,
    y2: 196.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_3124_5336",
    x1: 331.745,
    y1: 167.944,
    x2: 332.715,
    y2: 167.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_3124_5336",
    x1: 282.36,
    y1: 215.201,
    x2: 338.629,
    y2: 191.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_3124_5336",
    x1: 277.726,
    y1: 209.943,
    x2: 337.415,
    y2: 186.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_3124_5336",
    x1: 272.758,
    y1: 194.231,
    x2: 274.381,
    y2: 194.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_3124_5336",
    x1: 276.269,
    y1: 198.904,
    x2: 328.714,
    y2: 177.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_3124_5336",
    x1: 277.744,
    y1: 182.416,
    x2: 315.499,
    y2: 165.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckLeftDown);
export default __webpack_public_path__ + "static/media/truck-left-down.6e3337b2ffa105936f77ecfb335e2ac7.svg";
export { ForwardRef as ReactComponent };